import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  GenericScalar: any;
};

export type AddAbbonamento = {
  __typename?: 'AddAbbonamento';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type AddItem = {
  __typename?: 'AddItem';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type AdoptionDetailsType = {
  __typename?: 'AdoptionDetailsType';
  certificateUrl?: Maybe<Scalars['String']>;
  fruitDescription?: Maybe<Scalars['String']>;
  fruitName?: Maybe<Scalars['String']>;
  treeLabel?: Maybe<Scalars['String']>;
  treeName?: Maybe<Scalars['String']>;
  treePosition?: Maybe<Scalars['Int']>;
  utenteId?: Maybe<Scalars['Int']>;
};

export type AlberiAdottatiType = {
  __typename?: 'AlberiAdottatiType';
  adottati?: Maybe<Scalars['Int']>;
  totale?: Maybe<Scalars['Int']>;
  ultimi?: Maybe<Array<Maybe<RichiestaAlberoType>>>;
};

export type AlberoUtenteType = {
  __typename?: 'AlberoUtenteType';
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  idAdozione: Scalars['Int'];
  idAlbero: Scalars['Int'];
  idCustomer: Scalars['Int'];
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  posizione?: Maybe<Scalars['String']>;
  tipo?: Maybe<Scalars['String']>;
  utente?: Maybe<UtenteNode>;
};

export type AnnullaOrdine = {
  __typename?: 'AnnullaOrdine';
  message?: Maybe<Scalars['String']>;
  order?: Maybe<OrdineNode>;
  status?: Maybe<Scalars['Boolean']>;
};

export type ApplicationLogicsStructureDataType = {
  __typename?: 'ApplicationLogicsStructureDataType';
  data?: Maybe<Scalars['GenericScalar']>;
};

export type AppliedPromotionType = {
  __typename?: 'AppliedPromotionType';
  absoluteDiscount?: Maybe<Scalars['Float']>;
  promotion?: Maybe<PromotionNode>;
};

export type CarrelloType = {
  __typename?: 'CarrelloType';
  appliedPromotions?: Maybe<Array<Maybe<AppliedPromotionType>>>;
  items?: Maybe<Array<Maybe<PromotionalItemType>>>;
  numProdotti?: Maybe<Scalars['Int']>;
  prezzo?: Maybe<Scalars['Float']>;
  scontoAssoluto?: Maybe<Scalars['Float']>;
  scontoPercentuale?: Maybe<Scalars['Float']>;
  sistemaSpedizione?: Maybe<PromotionalShippingType>;
  totaleProdotti?: Maybe<Scalars['Float']>;
  totaleProdottiScontato?: Maybe<Scalars['Float']>;
  totaleScontato?: Maybe<Scalars['Float']>;
  totaleServizi?: Maybe<Scalars['Float']>;
};

export type CheckoutType = {
  __typename?: 'CheckoutType';
  appliedPromotions?: Maybe<Array<Maybe<AppliedPromotionType>>>;
  indirizzoFatturazione?: Maybe<IndirizzoNode>;
  indirizzoSpedizione?: Maybe<IndirizzoNode>;
  items?: Maybe<Array<Maybe<PromotionalItemType>>>;
  prezzo?: Maybe<Scalars['Float']>;
  scontoAssoluto?: Maybe<Scalars['Float']>;
  scontoPercentuale?: Maybe<Scalars['Float']>;
  sistemaPagamento?: Maybe<SistemaPagamentoType>;
  sistemaSpedizione?: Maybe<PromotionalShippingType>;
  sistemiPagamento?: Maybe<Array<Maybe<SistemaPagamentoType>>>;
  totaleProdotti?: Maybe<Scalars['Float']>;
  totaleProdottiScontato?: Maybe<Scalars['Float']>;
  totaleScontato?: Maybe<Scalars['Float']>;
  totaleScontatoNetto?: Maybe<Scalars['Float']>;
  totaleSenzaPromozioni?: Maybe<Scalars['Float']>;
  totaleServizi?: Maybe<Scalars['Float']>;
};

export type ConditionsStructureDataType = {
  __typename?: 'ConditionsStructureDataType';
  data?: Maybe<Scalars['GenericScalar']>;
};

export type ContentTypeNode = {
  __typename?: 'ContentTypeNode';
  appLabel: Scalars['String'];
  id: Scalars['ID'];
  model: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  /** Usato per le promozioni */
  prodottiAsParentContentType: ProdottoNodeConnection;
  prodottoSet: ProdottoNodeConnection;
  productRanges: Array<ProductRangeNode>;
};


export type ContentTypeNodeProdottiAsParentContentTypeArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ContentTypeNodeProdottoSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CreateIndirizzo = {
  __typename?: 'CreateIndirizzo';
  indirizzo?: Maybe<IndirizzoNode>;
};

export type CreateProductRange = {
  __typename?: 'CreateProductRange';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type CreatePromotion = {
  __typename?: 'CreatePromotion';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type CreateUserRange = {
  __typename?: 'CreateUserRange';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type DeleteIndirizzo = {
  __typename?: 'DeleteIndirizzo';
  message?: Maybe<Scalars['String']>;
};

export type DeleteProductRange = {
  __typename?: 'DeleteProductRange';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type DeletePromotion = {
  __typename?: 'DeletePromotion';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type DeleteUserRange = {
  __typename?: 'DeleteUserRange';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type DuplicateIndirizzo = {
  __typename?: 'DuplicateIndirizzo';
  indirizzo?: Maybe<IndirizzoNode>;
};

export type GaranziaNode = Node & {
  __typename?: 'GaranziaNode';
  attiva: Scalars['Boolean'];
  descrizione?: Maybe<Scalars['String']>;
  durata: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  nome?: Maybe<Scalars['String']>;
  prezzo?: Maybe<Scalars['Float']>;
  tooltip?: Maybe<Scalars['String']>;
};

export type GroupNode = {
  __typename?: 'GroupNode';
  id: Scalars['ID'];
  name: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  userRanges: Array<UserRangeNode>;
  /** I gruppi a cui appartiene l'utente. L'utente eredita tutti i permessi assegnati a ciascuno dei suoi gruppi. */
  userSet: UtenteNodeConnection;
};


export type GroupNodeUserSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type IndirizzoDeleteInput = {
  pk: Scalars['Int'];
};

export type IndirizzoDuplicateInput = {
  isFatturazione: Scalars['Boolean'];
  pk: Scalars['Int'];
};

export type IndirizzoInput = {
  cap: Scalars['String'];
  cf?: InputMaybe<Scalars['String']>;
  citta: Scalars['String'];
  civico: Scalars['String'];
  cognome?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  indirizzo: Scalars['String'];
  informazioniAggiuntive?: InputMaybe<Scalars['String']>;
  isFatturazione: Scalars['Boolean'];
  nome?: InputMaybe<Scalars['String']>;
  pec?: InputMaybe<Scalars['String']>;
  piva?: InputMaybe<Scalars['String']>;
  privato: Scalars['Boolean'];
  provincia: Scalars['String'];
  ragioneSociale?: InputMaybe<Scalars['String']>;
  sdi?: InputMaybe<Scalars['String']>;
  telefono: Scalars['String'];
};

export type IndirizzoNode = Node & {
  __typename?: 'IndirizzoNode';
  /** Se valorizzato si tratta di un indirizzo relativo agli abbonamenti */
  apg: Scalars['Boolean'];
  cap?: Maybe<Scalars['String']>;
  cf?: Maybe<Scalars['String']>;
  citta?: Maybe<Scalars['String']>;
  civico?: Maybe<Scalars['String']>;
  cognome?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  default: Scalars['Boolean'];
  /** The ID of the object. */
  id: Scalars['ID'];
  indirizzo?: Maybe<Scalars['String']>;
  informazioniAggiuntive?: Maybe<Scalars['String']>;
  isFatturazione: Scalars['Boolean'];
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  ordiniAsFatturazione: OrdineNodeConnection;
  ordiniAsSpedizione: OrdineNodeConnection;
  pec?: Maybe<Scalars['String']>;
  piva?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  privato: Scalars['Boolean'];
  provincia?: Maybe<Scalars['String']>;
  ragioneSociale?: Maybe<Scalars['String']>;
  sdi?: Maybe<Scalars['String']>;
  telefono?: Maybe<Scalars['String']>;
  utente: UtenteNode;
};


export type IndirizzoNodeOrdiniAsFatturazioneArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type IndirizzoNodeOrdiniAsSpedizioneArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type IndirizzoNodeConnection = {
  __typename?: 'IndirizzoNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IndirizzoNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `IndirizzoNode` and its cursor. */
export type IndirizzoNodeEdge = {
  __typename?: 'IndirizzoNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IndirizzoNode>;
};

export type IndirizzoSetDefaultInput = {
  pk: Scalars['Int'];
};

export type IndirizzoUpdateInput = {
  cap?: InputMaybe<Scalars['String']>;
  cf?: InputMaybe<Scalars['String']>;
  citta?: InputMaybe<Scalars['String']>;
  civico?: InputMaybe<Scalars['String']>;
  cognome?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  indirizzo?: InputMaybe<Scalars['String']>;
  informazioniAggiuntive?: InputMaybe<Scalars['String']>;
  nome?: InputMaybe<Scalars['String']>;
  pec?: InputMaybe<Scalars['String']>;
  piva?: InputMaybe<Scalars['String']>;
  pk: Scalars['Int'];
  privato: Scalars['Boolean'];
  provincia?: InputMaybe<Scalars['String']>;
  ragioneSociale?: InputMaybe<Scalars['String']>;
  sdi?: InputMaybe<Scalars['String']>;
  telefono?: InputMaybe<Scalars['String']>;
};

export type IssueInput = {
  cmIssue?: InputMaybe<Scalars['String']>;
  nominalIssueDate?: InputMaybe<Scalars['String']>;
};

export type IssueType = {
  __typename?: 'IssueType';
  cmIssue?: Maybe<Scalars['String']>;
  descriptionPeriod?: Maybe<Scalars['String']>;
  nominalIssueDate?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAbbonamento?: Maybe<AddAbbonamento>;
  addItem?: Maybe<AddItem>;
  annullaOrdine?: Maybe<AnnullaOrdine>;
  createIndirizzo?: Maybe<CreateIndirizzo>;
  createProductRange?: Maybe<CreateProductRange>;
  createPromotion?: Maybe<CreatePromotion>;
  createUserRange?: Maybe<CreateUserRange>;
  deleteIndirizzo?: Maybe<DeleteIndirizzo>;
  deleteProductRange?: Maybe<DeleteProductRange>;
  deletePromotion?: Maybe<DeletePromotion>;
  deleteUserRange?: Maybe<DeleteUserRange>;
  duplicateIndirizzo?: Maybe<DuplicateIndirizzo>;
  removeItem?: Maybe<RemoveItem>;
  removePromoCode?: Maybe<RemovePromoCode>;
  richiediAlbero?: Maybe<RichiediAlbero>;
  richiediReso?: Maybe<RichiediReso>;
  setCartadeldocente?: Maybe<SetCartaDelDocente>;
  setCheckout?: Maybe<SetCheckout>;
  setDefaultIndirizzo?: Maybe<SetDefaultIndirizzo>;
  setIndirizzi?: Maybe<SetIndirizzi>;
  setPromoCode?: Maybe<SetPromoCode>;
  updateGaranzia?: Maybe<UpdateGaranzia>;
  updateIndirizzo?: Maybe<UpdateIndirizzo>;
  updateIssue?: Maybe<UpdateIssue>;
  updateProductRange?: Maybe<UpdateProductRange>;
  updatePromotion?: Maybe<UpdatePromotion>;
  updateUserRange?: Maybe<UpdateUserRange>;
};


export type MutationAddAbbonamentoArgs = {
  rivista?: InputMaybe<Scalars['Int']>;
};


export type MutationAddItemArgs = {
  garanzia?: InputMaybe<Scalars['Boolean']>;
  item?: InputMaybe<Scalars['Int']>;
  quantita?: InputMaybe<Scalars['Int']>;
};


export type MutationAnnullaOrdineArgs = {
  orderId?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateIndirizzoArgs = {
  input: IndirizzoInput;
};


export type MutationCreateProductRangeArgs = {
  input: ProductRangeInput;
};


export type MutationCreatePromotionArgs = {
  input: PromotionInput;
};


export type MutationCreateUserRangeArgs = {
  input: UserRangeInput;
};


export type MutationDeleteIndirizzoArgs = {
  input: IndirizzoDeleteInput;
};


export type MutationDeleteProductRangeArgs = {
  pk: Scalars['Int'];
};


export type MutationDeletePromotionArgs = {
  pk: Scalars['Int'];
};


export type MutationDeleteUserRangeArgs = {
  pk: Scalars['Int'];
};


export type MutationDuplicateIndirizzoArgs = {
  input: IndirizzoDuplicateInput;
};


export type MutationRemoveItemArgs = {
  item?: InputMaybe<Scalars['Int']>;
};


export type MutationRichiediAlberoArgs = {
  input: RichiestaAlberoInput;
};


export type MutationRichiediResoArgs = {
  richiestaReso: RichiediResoInput;
};


export type MutationSetCartadeldocenteArgs = {
  codiceVoucher: Scalars['String'];
};


export type MutationSetCheckoutArgs = {
  codiceCartadeldocente?: InputMaybe<Scalars['String']>;
  sistemaPagamento?: InputMaybe<Scalars['Int']>;
};


export type MutationSetDefaultIndirizzoArgs = {
  input: IndirizzoSetDefaultInput;
};


export type MutationSetIndirizziArgs = {
  indirizzoFatturazione?: InputMaybe<Scalars['Int']>;
  indirizzoSpedizione?: InputMaybe<Scalars['Int']>;
};


export type MutationSetPromoCodeArgs = {
  promoCode?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateGaranziaArgs = {
  garanzia?: InputMaybe<Scalars['Boolean']>;
  riga?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateIndirizzoArgs = {
  input: IndirizzoUpdateInput;
};


export type MutationUpdateIssueArgs = {
  issue: IssueInput;
  riga?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateProductRangeArgs = {
  input: ProductRangeUpdateInput;
};


export type MutationUpdatePromotionArgs = {
  input: PromotionUpdateInput;
};


export type MutationUpdateUserRangeArgs = {
  input: UserRangeUpdateInput;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type OrdineNode = Node & {
  __typename?: 'OrdineNode';
  annullabile?: Maybe<Scalars['Boolean']>;
  attivo?: Maybe<Scalars['Boolean']>;
  causale?: Maybe<Scalars['String']>;
  cf?: Maybe<Scalars['String']>;
  codiceCartadeldocente?: Maybe<Scalars['String']>;
  cognome?: Maybe<Scalars['String']>;
  costoSpedizione: Scalars['Float'];
  created?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['String']>;
  dataFattura?: Maybe<Scalars['Date']>;
  dataNdc?: Maybe<Scalars['Date']>;
  /** Valorizzato quando l'ordine ha dei prodotti in abbonamento */
  elementiAbbonamento: Scalars['Boolean'];
  /** Valorizzato quando l'ordine ha dei prodotti in dropshipping */
  elementiDropshipping: Scalars['Boolean'];
  /** Valorizzato quando l'ordine ha dei prodotti da spedire */
  elementiSpedibili: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  etichettaReso?: Maybe<Scalars['String']>;
  /** Valorizzato quando è stata generata la fattura elettronica */
  fattele: Scalars['Boolean'];
  fatturaWeb?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  impostaIva?: Maybe<Scalars['Float']>;
  indirizzoFatturazione?: Maybe<IndirizzoNode>;
  indirizzoSpedizione?: Maybe<IndirizzoNode>;
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  numeroFattura?: Maybe<Scalars['String']>;
  numeroNdc?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['String']>;
  pec?: Maybe<Scalars['String']>;
  piva?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  prezzoTotale: Scalars['Float'];
  prezzoTotaleScontato: Scalars['Float'];
  prezzoTotaleServizi?: Maybe<Scalars['Float']>;
  privato?: Maybe<Scalars['Boolean']>;
  promoCode?: Maybe<Scalars['String']>;
  promozione?: Maybe<PromotionNode>;
  promozioneValoreAssoluto?: Maybe<Scalars['Float']>;
  promozioneValorePercentuale: Scalars['Float'];
  ragioneSociale?: Maybe<Scalars['String']>;
  rendibile?: Maybe<Scalars['Boolean']>;
  richiesteReso: Array<RichiestaResoNode>;
  righeOrdine?: Maybe<Array<Maybe<RigaOrdineNode>>>;
  righeOrdineProdotti?: Maybe<Array<Maybe<RigaOrdineNode>>>;
  /** Valorizzato quando l'ordine è un rinnovo automatico di un abbonamento */
  rinnovoAutomatico: Scalars['Boolean'];
  sdi?: Maybe<Scalars['String']>;
  sentApg?: Maybe<Scalars['Boolean']>;
  /** Sequenziale univoco per SAP */
  sequenziale?: Maybe<Scalars['Int']>;
  sistemaPagamento?: Maybe<SistemaPagamentoType>;
  sistemaSpedizione?: Maybe<SistemaSpedizioneType>;
  stato?: Maybe<StatoNode>;
  statusReso?: Maybe<Scalars['String']>;
  totaleProdottiScontato: Scalars['Float'];
  /** Campo VBELN_CONS da SAP */
  tracking?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  utente?: Maybe<UtenteNode>;
  /** Numero di bolla da SAP */
  vbeln?: Maybe<Scalars['String']>;
};

export type OrdineNodeConnection = {
  __typename?: 'OrdineNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrdineNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrdineNode` and its cursor. */
export type OrdineNodeEdge = {
  __typename?: 'OrdineNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrdineNode>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type ProdottoNode = Node & {
  __typename?: 'ProdottoNode';
  bundle: Scalars['Boolean'];
  codiceIva?: Maybe<Scalars['String']>;
  contentType: ContentTypeNode;
  created?: Maybe<Scalars['DateTime']>;
  descrizione?: Maybe<Scalars['String']>;
  disclaimerPrevendita?: Maybe<Scalars['String']>;
  disponibile?: Maybe<Scalars['Boolean']>;
  /** ID template email Magnews specifico per conferma ordine */
  emailTemplate?: Maybe<Scalars['Int']>;
  garanzia?: Maybe<GaranziaNode>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isPrevendita?: Maybe<Scalars['Boolean']>;
  isbn?: Maybe<Scalars['String']>;
  iva?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modified?: Maybe<Scalars['DateTime']>;
  /** Usato per le promozioni */
  parentContentType?: Maybe<ContentTypeNode>;
  pk?: Maybe<Scalars['Int']>;
  prezzo?: Maybe<Scalars['Float']>;
  prezzoScontato?: Maybe<Scalars['Float']>;
  prodottiAsBundle?: Maybe<Array<Maybe<PromotionalItemType>>>;
  prodottiBundle?: Maybe<Array<Maybe<PromotionalItemType>>>;
  productRanges: Array<ProductRangeNode>;
  quantita?: Maybe<Scalars['Int']>;
  righeCarrello: Array<RigaCarrelloNode>;
  righeCheckout: Array<RigaCheckoutNode>;
  righeOrdine: RigaOrdineNodeConnection;
  righeWishlist: Array<RigaWishlistNode>;
  rinnovo?: Maybe<Scalars['Boolean']>;
  scontoPercentuale?: Maybe<Scalars['Int']>;
  /** Sistemi di pagamento abilitati all'acquisto del prodotto (se vuoto -> tutti) */
  sistemiPagamento: Array<SistemaPagamentoType>;
  tipo?: Maybe<Scalars['String']>;
  tipologia?: Maybe<Scalars['String']>;
  titolo?: Maybe<Scalars['String']>;
  titoloAdmin?: Maybe<Scalars['String']>;
  tooltipImage?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  vendutoSingolarmente: Scalars['Boolean'];
};


export type ProdottoNodeRigheOrdineArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ProdottoNodeConnection = {
  __typename?: 'ProdottoNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProdottoNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProdottoNode` and its cursor. */
export type ProdottoNodeEdge = {
  __typename?: 'ProdottoNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProdottoNode>;
};

export type ProductRangeInput = {
  allProducts?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  productAttributes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productContentTypes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  products?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type: Scalars['String'];
};

export type ProductRangeNode = {
  __typename?: 'ProductRangeNode';
  allProducts: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  productAttributes?: Maybe<Array<Maybe<ValoreAttributoNode>>>;
  productContentTypes?: Maybe<Array<Maybe<ContentTypeNode>>>;
  products?: Maybe<Array<Maybe<ProdottoNode>>>;
  type?: Maybe<Scalars['String']>;
};

export type ProductRangeUpdateInput = {
  allProducts?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pk: Scalars['Int'];
  productAttributes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productContentTypes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  products?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type: Scalars['String'];
};

export type PromotionInput = {
  attivaTramiteCoupon?: InputMaybe<Scalars['Boolean']>;
  benefits?: InputMaybe<Array<InputMaybe<Scalars['GenericScalar']>>>;
  conditions?: InputMaybe<Array<InputMaybe<Scalars['GenericScalar']>>>;
  context: Scalars['String'];
  coupon?: InputMaybe<Scalars['Boolean']>;
  cumulative?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['GenericScalar']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  promoCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type PromotionNode = {
  __typename?: 'PromotionNode';
  applicationLogics?: Maybe<Scalars['GenericScalar']>;
  attivaTramiteCoupon: Scalars['Boolean'];
  conditions?: Maybe<Scalars['GenericScalar']>;
  context?: Maybe<Scalars['String']>;
  /** Indica se è un coupon */
  coupon: Scalars['Boolean'];
  created?: Maybe<Scalars['DateTime']>;
  cumulative: Scalars['Boolean'];
  date?: Maybe<Scalars['GenericScalar']>;
  description?: Maybe<Scalars['String']>;
  endDatetime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  /** Number of times the promotion has been applied */
  numApplications: Scalars['Int'];
  ordini: OrdineNodeConnection;
  pk?: Maybe<Scalars['Int']>;
  promoCode?: Maybe<Scalars['String']>;
  promoCodeAdmin?: Maybe<Scalars['GenericScalar']>;
  promoCoupon?: Maybe<Scalars['String']>;
  righeOrdine: RigaOrdineNodeConnection;
  slug: Scalars['String'];
  startDatetime?: Maybe<Scalars['DateTime']>;
  status: PromotionStatus;
  statusAdmin?: Maybe<Scalars['Boolean']>;
};


export type PromotionNodeOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PromotionNodeRigheOrdineArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum PromotionStatus {
  /** The promotion is not active */
  Closed = 'CLOSED',
  /** The promotion has already been used */
  Consumed = 'CONSUMED',
  /** The promotion is active */
  Open = 'OPEN'
}

export type PromotionUpdateInput = {
  attivaTramiteCoupon?: InputMaybe<Scalars['Boolean']>;
  benefits?: InputMaybe<Array<InputMaybe<Scalars['GenericScalar']>>>;
  conditions?: InputMaybe<Array<InputMaybe<Scalars['GenericScalar']>>>;
  context?: InputMaybe<Scalars['String']>;
  coupon?: InputMaybe<Scalars['Boolean']>;
  cumulative?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['GenericScalar']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pk: Scalars['Int'];
  promoCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type PromotionalItemType = {
  __typename?: 'PromotionalItemType';
  absoluteDiscount?: Maybe<Scalars['Float']>;
  appliedPromotions?: Maybe<Array<Maybe<AppliedPromotionType>>>;
  cartRow?: Maybe<RigaType>;
  discountedUnitPrice?: Maybe<Scalars['Float']>;
  percentageDiscount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalDiscounted?: Maybe<Scalars['Float']>;
};

export type PromotionalShippingType = {
  __typename?: 'PromotionalShippingType';
  absoluteDiscount?: Maybe<Scalars['Float']>;
  appliedPromotions?: Maybe<Array<Maybe<AppliedPromotionType>>>;
  discountedUnitPrice?: Maybe<Scalars['Float']>;
  percentageDiscount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalDiscounted?: Maybe<Scalars['Float']>;
};

export type Query = {
  __typename?: 'Query';
  adoptionDetails?: Maybe<AdoptionDetailsType>;
  alberiAdottati?: Maybe<AlberiAdottatiType>;
  alberoUpdates?: Maybe<Array<Maybe<SingleUpdateType>>>;
  applicationLogicsStructureData?: Maybe<ApplicationLogicsStructureDataType>;
  cart?: Maybe<CarrelloType>;
  checkout?: Maybe<CheckoutType>;
  conditionsStructureData?: Maybe<ConditionsStructureDataType>;
  findIssues: Array<Maybe<IssueType>>;
  indirizzi?: Maybe<IndirizzoNodeConnection>;
  isAbbonato: Scalars['Boolean'];
  me?: Maybe<UtenteNode>;
  ordine?: Maybe<OrdineNode>;
  ordineCheckout?: Maybe<OrdineNode>;
  ordineReso?: Maybe<OrdineNode>;
  ordini?: Maybe<OrdineNodeConnection>;
  prodottiAsBundle?: Maybe<ProdottoNode>;
  productRange?: Maybe<ProductRangeNode>;
  productRangeTypes?: Maybe<Array<Maybe<SelectType>>>;
  productRanges?: Maybe<Array<Maybe<ProductRangeNode>>>;
  promotion?: Maybe<PromotionNode>;
  promotionAttributes?: Maybe<Array<Maybe<ValoreAttributoNode>>>;
  promotionContentTypes?: Maybe<Array<Maybe<ContentTypeNode>>>;
  promotionContexts?: Maybe<Array<Maybe<SelectType>>>;
  promotionGroups?: Maybe<Array<Maybe<GroupNode>>>;
  searchProduct?: Maybe<Array<Maybe<ProdottoNode>>>;
  searchUser?: Maybe<Array<Maybe<UtenteNode>>>;
  tipiAlbero?: Maybe<Array<Maybe<TipoAlberoType>>>;
  userRange?: Maybe<UserRangeNode>;
  userRangeTypes?: Maybe<Array<Maybe<SelectType>>>;
  userRanges?: Maybe<Array<Maybe<UserRangeNode>>>;
  wishlist?: Maybe<WishlistType>;
};


export type QueryAdoptionDetailsArgs = {
  idAdozione?: InputMaybe<Scalars['String']>;
};


export type QueryAlberiAdottatiArgs = {
  utenteId?: InputMaybe<Scalars['Int']>;
};


export type QueryAlberoUpdatesArgs = {
  idAdozione?: InputMaybe<Scalars['String']>;
};


export type QueryFindIssuesArgs = {
  riga: Scalars['Int'];
};


export type QueryIndirizziArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isFatturazione?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryIsAbbonatoArgs = {
  rivista: Scalars['Int'];
};


export type QueryOrdineArgs = {
  pk?: InputMaybe<Scalars['Int']>;
};


export type QueryOrdineResoArgs = {
  pk?: InputMaybe<Scalars['Int']>;
};


export type QueryOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryProdottiAsBundleArgs = {
  pk: Scalars['Int'];
};


export type QueryProductRangeArgs = {
  pk: Scalars['Int'];
};


export type QueryProductRangesArgs = {
  conditionType: Scalars['String'];
};


export type QueryPromotionArgs = {
  pk: Scalars['Int'];
};


export type QuerySearchProductArgs = {
  keyword: Scalars['String'];
};


export type QuerySearchUserArgs = {
  keyword: Scalars['String'];
};


export type QueryUserRangeArgs = {
  pk: Scalars['Int'];
};


export type QueryUserRangesArgs = {
  conditionType: Scalars['String'];
};

export type RemoveItem = {
  __typename?: 'RemoveItem';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type RemovePromoCode = {
  __typename?: 'RemovePromoCode';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type RichiediAlbero = {
  __typename?: 'RichiediAlbero';
  status?: Maybe<Scalars['Boolean']>;
};

export type RichiediReso = {
  __typename?: 'RichiediReso';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type RichiediResoInput = {
  ordine: Scalars['Int'];
  righe: Scalars['GenericScalar'];
};

export type RichiestaAlberoInput = {
  biorfarm: Scalars['Boolean'];
  citta: Scalars['String'];
  classe: Scalars['String'];
  giuntiscuola: Scalars['Boolean'];
  nome: Scalars['String'];
  provincia: Scalars['String'];
  scuola: Scalars['String'];
  sezione: Scalars['String'];
  tipo: Scalars['Int'];
};

export type RichiestaAlberoType = {
  __typename?: 'RichiestaAlberoType';
  agente?: Maybe<UtenteNode>;
  /** Comunicazioni marketing Biorfarm */
  biorfarm?: Maybe<Scalars['Boolean']>;
  citta?: Maybe<Scalars['String']>;
  classe?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  errors?: Maybe<Scalars['String']>;
  esito?: Maybe<Scalars['Boolean']>;
  /** Comunicazioni marketing Giunti Scuola */
  giuntiscuola?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  /** Nome dato all'albero */
  nome?: Maybe<Scalars['String']>;
  nomeLatino?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  provincia?: Maybe<Scalars['String']>;
  scuola?: Maybe<Scalars['String']>;
  sezione?: Maybe<Scalars['String']>;
  tipo?: Maybe<TipoAlberoType>;
  url?: Maybe<Scalars['String']>;
  utente?: Maybe<UtenteNode>;
};

export type RichiestaResoNode = {
  __typename?: 'RichiestaResoNode';
  codice?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  ordine: OrdineNode;
  prezzoTotale: Scalars['Float'];
  prezzoTotaleScontato: Scalars['Float'];
  prezzoTotaleScontatoNetto: Scalars['Float'];
  promozioneValoreAssoluto: Scalars['Float'];
  righeRichiestaReso: Array<RigaRichiestaResoNode>;
  stato: RichiestaResoStato;
};

/** An enumeration. */
export enum RichiestaResoStato {
  /** Accettato */
  Accettato = 'ACCETTATO',
  /** Pending */
  Pending = 'PENDING',
  /** Rifiutato */
  Rifiutato = 'RIFIUTATO'
}

export type RigaCarrelloNode = {
  __typename?: 'RigaCarrelloNode';
  /** Primo fascicolo a cui ha diritto */
  cmFirstIssue?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  /** Data di inizio abbonamento */
  dataInizio?: Maybe<Scalars['Date']>;
  garanzia: Scalars['Boolean'];
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  omaggio: Scalars['Boolean'];
  pk?: Maybe<Scalars['Int']>;
  prodotto?: Maybe<ProdottoNode>;
  quantita: Scalars['Int'];
  utente?: Maybe<UtenteNode>;
};

export type RigaCheckoutNode = {
  __typename?: 'RigaCheckoutNode';
  /** Primo fascicolo a cui ha diritto */
  cmFirstIssue?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  /** Data di inizio abbonamento */
  dataInizio?: Maybe<Scalars['Date']>;
  garanzia: Scalars['Boolean'];
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  omaggio: Scalars['Boolean'];
  pk?: Maybe<Scalars['Int']>;
  prodotto?: Maybe<ProdottoNode>;
  quantita: Scalars['Int'];
  utente?: Maybe<UtenteNode>;
};

export type RigaOrdineNode = Node & {
  __typename?: 'RigaOrdineNode';
  /** Primo fascicolo a cui ha diritto */
  cmFirstIssue?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  /** Data di inizio abbonamento */
  dataInizio?: Maybe<Scalars['Date']>;
  garanzia: Scalars['Boolean'];
  /** The ID of the object. */
  id: Scalars['ID'];
  inPrevendita: Scalars['Boolean'];
  modified?: Maybe<Scalars['DateTime']>;
  omaggio: Scalars['Boolean'];
  ordine: OrdineNode;
  pk?: Maybe<Scalars['Int']>;
  prezzoTotale: Scalars['Float'];
  prezzoTotaleScontato: Scalars['Float'];
  prezzoTotaleServizi?: Maybe<Scalars['Float']>;
  prezzoUnitario: Scalars['Float'];
  prezzoUnitarioScontato: Scalars['Float'];
  prodotto?: Maybe<ProdottoNode>;
  promozione?: Maybe<PromotionNode>;
  promozioneValoreAssoluto: Scalars['Float'];
  promozioneValorePercentuale: Scalars['Float'];
  quantitaOrdinata: Scalars['Int'];
  quantitaResa: Scalars['Int'];
  quantitaResoRichiesta?: Maybe<Scalars['Int']>;
  resa: Scalars['Boolean'];
  righeRichiestaReso: Array<RigaRichiestaResoNode>;
  tipologia: RigaOrdineTipologia;
};

export type RigaOrdineNodeConnection = {
  __typename?: 'RigaOrdineNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RigaOrdineNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RigaOrdineNode` and its cursor. */
export type RigaOrdineNodeEdge = {
  __typename?: 'RigaOrdineNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<RigaOrdineNode>;
};

/** An enumeration. */
export enum RigaOrdineTipologia {
  /** prodotto */
  Prodotto = 'PRODOTTO',
  /** spedizione */
  Spedizione = 'SPEDIZIONE'
}

export type RigaRichiestaResoNode = {
  __typename?: 'RigaRichiestaResoNode';
  id: Scalars['ID'];
  prezzoTotale: Scalars['Float'];
  prezzoTotaleScontato: Scalars['Float'];
  prezzoUnitario: Scalars['Float'];
  prezzoUnitarioScontato: Scalars['Float'];
  quantitaResa?: Maybe<Scalars['Int']>;
  quantitaRichiesta?: Maybe<Scalars['Int']>;
  richiestaReso: RichiestaResoNode;
  rigaOrdine?: Maybe<RigaOrdineNode>;
  rigaOrdinePk?: Maybe<Scalars['Int']>;
};

export type RigaType = ProdottoNode | RigaCarrelloNode | RigaCheckoutNode | RigaWishlistNode;

export type RigaWishlistNode = {
  __typename?: 'RigaWishlistNode';
  /** Primo fascicolo a cui ha diritto */
  cmFirstIssue?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  /** Data di inizio abbonamento */
  dataInizio?: Maybe<Scalars['Date']>;
  garanzia: Scalars['Boolean'];
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  omaggio: Scalars['Boolean'];
  pk?: Maybe<Scalars['Int']>;
  prodotto?: Maybe<ProdottoNode>;
  quantita: Scalars['Int'];
  sessionKey?: Maybe<Scalars['String']>;
  utente?: Maybe<UtenteNode>;
};

export type SelectType = {
  __typename?: 'SelectType';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SetCartaDelDocente = {
  __typename?: 'SetCartaDelDocente';
  importo?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type SetCheckout = {
  __typename?: 'SetCheckout';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type SetDefaultIndirizzo = {
  __typename?: 'SetDefaultIndirizzo';
  message?: Maybe<Scalars['String']>;
};

export type SetIndirizzi = {
  __typename?: 'SetIndirizzi';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type SetPromoCode = {
  __typename?: 'SetPromoCode';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type SingleUpdateType = {
  __typename?: 'SingleUpdateType';
  data?: Maybe<Scalars['DateTime']>;
  descrizione?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SistemaPagamentoType = {
  __typename?: 'SistemaPagamentoType';
  /** Utilizzabile per pagare abbonamenti */
  abbonamenti: Scalars['Boolean'];
  alias: Scalars['String'];
  attivo: Scalars['Boolean'];
  className: Scalars['String'];
  created?: Maybe<Scalars['DateTime']>;
  descrizione?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  ordinamento: Scalars['Int'];
  ordini: OrdineNodeConnection;
  pk?: Maybe<Scalars['Int']>;
  /** Sistemi di pagamento abilitati all'acquisto del prodotto (se vuoto -> tutti) */
  prodotti: ProdottoNodeConnection;
};


export type SistemaPagamentoTypeOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type SistemaPagamentoTypeProdottiArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type SistemaSpedizioneType = {
  __typename?: 'SistemaSpedizioneType';
  alias: Scalars['String'];
  attivo: Scalars['Boolean'];
  /** Utilizzata per comunicare il sistema di spedizione ad eventuali webservice */
  chiave?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  default: Scalars['Boolean'];
  descrizione?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  ordinamento: Scalars['Int'];
  ordini: OrdineNodeConnection;
  pk?: Maybe<Scalars['Int']>;
  prezzo?: Maybe<Scalars['Float']>;
  prezzoScontato?: Maybe<Scalars['Float']>;
  scontoAssoluto?: Maybe<Scalars['Float']>;
  scontoPercentuale?: Maybe<Scalars['Float']>;
};


export type SistemaSpedizioneTypeOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type StatoNode = Node & {
  __typename?: 'StatoNode';
  alias: Scalars['String'];
  /** Stato visibile in myaccount */
  attivo: Scalars['Boolean'];
  azione?: Maybe<Scalars['String']>;
  chiave?: Maybe<Scalars['String']>;
  colorBackend?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  nome: Scalars['String'];
  ordine: Scalars['Int'];
  ordini: OrdineNodeConnection;
  pk?: Maybe<Scalars['Int']>;
  statiConsentiti: StatoNodeConnection;
  statoSet: StatoNodeConnection;
};


export type StatoNodeOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StatoNodeStatiConsentitiArgs = {
  after?: InputMaybe<Scalars['String']>;
  attivo?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  chiave?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StatoNodeStatoSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  attivo?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  chiave?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type StatoNodeConnection = {
  __typename?: 'StatoNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StatoNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StatoNode` and its cursor. */
export type StatoNodeEdge = {
  __typename?: 'StatoNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StatoNode>;
};

export type TipoAlberoType = {
  __typename?: 'TipoAlberoType';
  agricoltore?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ids: Scalars['String'];
  modified?: Maybe<Scalars['DateTime']>;
  pk?: Maybe<Scalars['Int']>;
  prodotto?: Maybe<Scalars['String']>;
  quantita?: Maybe<Scalars['Int']>;
  regione?: Maybe<Scalars['String']>;
  richiesteTipoAlbero: Array<RichiestaAlberoType>;
};

export type UpdateGaranzia = {
  __typename?: 'UpdateGaranzia';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type UpdateIndirizzo = {
  __typename?: 'UpdateIndirizzo';
  indirizzo?: Maybe<IndirizzoNode>;
};

export type UpdateIssue = {
  __typename?: 'UpdateIssue';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type UpdateProductRange = {
  __typename?: 'UpdateProductRange';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type UpdatePromotion = {
  __typename?: 'UpdatePromotion';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type UpdateUserRange = {
  __typename?: 'UpdateUserRange';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type UserRangeInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
  userCategories?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type UserRangeNode = {
  __typename?: 'UserRangeNode';
  adminData?: Maybe<Scalars['GenericScalar']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  userCategories?: Maybe<Array<Maybe<GroupNode>>>;
  users?: Maybe<Array<Maybe<UtenteNode>>>;
};

export type UserRangeUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pk: Scalars['Int'];
  type: Scalars['String'];
  userCategories?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type UtenteNode = Node & {
  __typename?: 'UtenteNode';
  /** Ha accettato le nuove condizioni di privacy */
  aggiornamentoPrivacy?: Maybe<Scalars['Boolean']>;
  aieId?: Maybe<Scalars['String']>;
  alberoutenteSet: Array<AlberoUtenteType>;
  biografia?: Maybe<Scalars['String']>;
  cf?: Maybe<Scalars['String']>;
  codiceAgente?: Maybe<Scalars['String']>;
  cognome?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  dateJoined: Scalars['DateTime'];
  email: Scalars['String'];
  emailConfermata: Scalars['Boolean'];
  esperto: Scalars['Boolean'];
  /** Ha dato la disponibilità ad essere contattato */
  flagContatti: Scalars['Boolean'];
  /** Il suo profilo è pubblico */
  flagPubblico: Scalars['Boolean'];
  /** I gruppi a cui appartiene l'utente. L'utente eredita tutti i permessi assegnati a ciascuno dei suoi gruppi. */
  groups: Array<GroupNode>;
  hasNuoveRisorse: Scalars['Boolean'];
  /** Biografia breve */
  headline?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  /** Codice univoco di APG */
  idCustomer?: Maybe<Scalars['String']>;
  idOld?: Maybe<Scalars['Float']>;
  importJson?: Maybe<Scalars['String']>;
  indirizzi: IndirizzoNodeConnection;
  /** Indica se l'utente si può loggare o meno */
  isActive: Scalars['Boolean'];
  /** Utente migrato da vecchio sito */
  isOld: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  /** Attribuisce all'utente tutti i privilegi, senza che sia necessario assegnarli esplicitamente. */
  isSuperuser: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  nome?: Maybe<Scalars['String']>;
  /** Utente migrato da vecchio sito che ha completato la registrazione */
  normalizzato: Scalars['Boolean'];
  /** Numero estratto assegnato all'uitente per la lotteria aziendale */
  numeroLotteria?: Maybe<Scalars['Int']>;
  ordineDiScuola?: Maybe<ValoreAttributoNode>;
  ordini: OrdineNodeConnection;
  password: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  privacy: Scalars['Boolean'];
  privacyCommerciale: Scalars['Boolean'];
  privacyProfilazione: Scalars['Boolean'];
  provincia?: Maybe<UtenteProvincia>;
  /** L'utente non è della community */
  redazionale: Scalars['Boolean'];
  richiesteAlberoAgente: Array<RichiestaAlberoType>;
  richiesteAlberoUtente: Array<RichiestaAlberoType>;
  richiesteValidazione: UtenteNodeConnection;
  righeCarrello: Array<RigaCarrelloNode>;
  righeCheckout: Array<RigaCheckoutNode>;
  righeWishlist: Array<RigaWishlistNode>;
  ruolo?: Maybe<UtenteRuolo>;
  /** Indica se ha confermato la scuola per l'anno scolastico corrente */
  scuolaConfermata: Scalars['Boolean'];
  /** Se a True vuol dire che deve essere sincronizzato con permessi tdz tramite send_user_info */
  sendUserInfo: Scalars['Boolean'];
  slug?: Maybe<Scalars['String']>;
  telefono?: Maybe<Scalars['String']>;
  /** È stato tentato il recupero dell'uid tramite cron job */
  tentatoRecupero: Scalars['Boolean'];
  /** Codice univoco di CAS */
  uid?: Maybe<Scalars['String']>;
  ultimoAccessoAreaPersonale?: Maybe<Scalars['DateTime']>;
  userRanges: Array<UserRangeNode>;
  username: Scalars['String'];
  utenteSet: UtenteNodeConnection;
};


export type UtenteNodeIndirizziArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isFatturazione?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UtenteNodeOrdiniArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UtenteNodeRichiesteValidazioneArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UtenteNodeUtenteSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type UtenteNodeConnection = {
  __typename?: 'UtenteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UtenteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UtenteNode` and its cursor. */
export type UtenteNodeEdge = {
  __typename?: 'UtenteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UtenteNode>;
};

/** An enumeration. */
export enum UtenteProvincia {
  /** Agrigento */
  Ag = 'AG',
  /** Alessandria */
  Al = 'AL',
  /** Ancona */
  An = 'AN',
  /** Aosta */
  Ao = 'AO',
  /** Ascoli Piceno */
  Ap = 'AP',
  /** L'Aquila */
  Aq = 'AQ',
  /** Arezzo */
  Ar = 'AR',
  /** Asti */
  At = 'AT',
  /** Avellino */
  Av = 'AV',
  /** Bari */
  Ba = 'BA',
  /** Bergamo */
  Bg = 'BG',
  /** Biella */
  Bi = 'BI',
  /** Belluno */
  Bl = 'BL',
  /** Benevento */
  Bn = 'BN',
  /** Bologna */
  Bo = 'BO',
  /** Brindisi */
  Br = 'BR',
  /** Brescia */
  Bs = 'BS',
  /** Barletta-Andria-Trani */
  Bt = 'BT',
  /** Bolzano/Bozen */
  Bz = 'BZ',
  /** Cagliari */
  Ca = 'CA',
  /** Campobasso */
  Cb = 'CB',
  /** Caserta */
  Ce = 'CE',
  /** Chieti */
  Ch = 'CH',
  /** Carbonia-Iglesias */
  Ci = 'CI',
  /** Caltanissetta */
  Cl = 'CL',
  /** Cuneo */
  Cn = 'CN',
  /** Como */
  Co = 'CO',
  /** Cremona */
  Cr = 'CR',
  /** Cosenza */
  Cs = 'CS',
  /** Catania */
  Ct = 'CT',
  /** Catanzaro */
  Cz = 'CZ',
  /** Enna */
  En = 'EN',
  /** Forlì-Cesena */
  Fc = 'FC',
  /** Ferrara */
  Fe = 'FE',
  /** Foggia */
  Fg = 'FG',
  /** Firenze */
  Fi = 'FI',
  /** Fermo */
  Fm = 'FM',
  /** Frosinone */
  Fr = 'FR',
  /** Genova */
  Ge = 'GE',
  /** Gorizia */
  Go = 'GO',
  /** Grosseto */
  Gr = 'GR',
  /** Imperia */
  Im = 'IM',
  /** Isernia */
  Is = 'IS',
  /** Crotone */
  Kr = 'KR',
  /** Lecco */
  Lc = 'LC',
  /** Lecce */
  Le = 'LE',
  /** Livorno */
  Li = 'LI',
  /** Lodi */
  Lo = 'LO',
  /** Latina */
  Lt = 'LT',
  /** Lucca */
  Lu = 'LU',
  /** Monza e della Brianza */
  Mb = 'MB',
  /** Macerata */
  Mc = 'MC',
  /** Messina */
  Me = 'ME',
  /** Milano */
  Mi = 'MI',
  /** Mantova */
  Mn = 'MN',
  /** Modena */
  Mo = 'MO',
  /** Massa-Carrara */
  Ms = 'MS',
  /** Matera */
  Mt = 'MT',
  /** Napoli */
  Na = 'NA',
  /** Novara */
  No = 'NO',
  /** Nuoro */
  Nu = 'NU',
  /** Ogliastra */
  Og = 'OG',
  /** Oristano */
  Or = 'OR',
  /** Olbia-Tempio */
  Ot = 'OT',
  /** Palermo */
  Pa = 'PA',
  /** Piacenza */
  Pc = 'PC',
  /** Padova */
  Pd = 'PD',
  /** Pescara */
  Pe = 'PE',
  /** Perugia */
  Pg = 'PG',
  /** Pisa */
  Pi = 'PI',
  /** Pordenone */
  Pn = 'PN',
  /** Prato */
  Po = 'PO',
  /** Parma */
  Pr = 'PR',
  /** Pistoia */
  Pt = 'PT',
  /** Pesaro e Urbino */
  Pu = 'PU',
  /** Pavia */
  Pv = 'PV',
  /** Potenza */
  Pz = 'PZ',
  /** Ravenna */
  Ra = 'RA',
  /** Reggio di Calabria */
  Rc = 'RC',
  /** Reggio nell'Emilia */
  Re = 'RE',
  /** Ragusa */
  Rg = 'RG',
  /** Rieti */
  Ri = 'RI',
  /** Roma */
  Rm = 'RM',
  /** Rimini */
  Rn = 'RN',
  /** Rovigo */
  Ro = 'RO',
  /** Salerno */
  Sa = 'SA',
  /** Siena */
  Si = 'SI',
  /** Sondrio */
  So = 'SO',
  /** La Spezia */
  Sp = 'SP',
  /** Siracusa */
  Sr = 'SR',
  /** Sassari */
  Ss = 'SS',
  /** Savona */
  Sv = 'SV',
  /** Taranto */
  Ta = 'TA',
  /** Teramo */
  Te = 'TE',
  /** Trento */
  Tn = 'TN',
  /** Torino */
  To = 'TO',
  /** Trapani */
  Tp = 'TP',
  /** Terni */
  Tr = 'TR',
  /** Trieste */
  Ts = 'TS',
  /** Treviso */
  Tv = 'TV',
  /** Udine */
  Ud = 'UD',
  /** Varese */
  Va = 'VA',
  /** Verbano-Cusio-Ossola */
  Vb = 'VB',
  /** Vercelli */
  Vc = 'VC',
  /** Venezia */
  Ve = 'VE',
  /** Vicenza */
  Vi = 'VI',
  /** Verona */
  Vr = 'VR',
  /** Medio Campidano */
  Vs = 'VS',
  /** Viterbo */
  Vt = 'VT',
  /** Vibo Valentia */
  Vv = 'VV'
}

/** An enumeration. */
export enum UtenteRuolo {
  /** Altro */
  A = 'A',
  /** Genitore */
  G = 'G',
  /** Insegnante */
  I = 'I',
  /** Studente */
  S = 'S'
}

export type ValoreAttributoNode = {
  __typename?: 'ValoreAttributoNode';
  children: Array<ValoreAttributoNode>;
  codice: Scalars['String'];
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  nome: Scalars['String'];
  ordine: Scalars['Int'];
  parent?: Maybe<ValoreAttributoNode>;
  pk?: Maybe<Scalars['Int']>;
  productRanges: Array<ProductRangeNode>;
  slug: Scalars['String'];
  utenti: UtenteNodeConnection;
};


export type ValoreAttributoNodeUtentiArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type WishlistType = {
  __typename?: 'WishlistType';
  items?: Maybe<Array<Maybe<PromotionalItemType>>>;
  numProdotti?: Maybe<Scalars['Int']>;
};

export type CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartQuery = { __typename?: 'Query', cart?: { __typename?: 'CarrelloType', totaleScontato?: number | null, totaleProdottiScontato?: number | null, totaleProdotti?: number | null, totaleServizi?: number | null, scontoAssoluto?: number | null, scontoPercentuale?: number | null, numProdotti?: number | null, items?: Array<{ __typename?: 'PromotionalItemType', total?: number | null, totalDiscounted?: number | null, percentageDiscount?: number | null, absoluteDiscount?: number | null, appliedPromotions?: Array<{ __typename?: 'AppliedPromotionType', promotion?: { __typename?: 'PromotionNode', pk?: number | null, name: string, promoCode?: string | null, promoCoupon?: string | null } | null } | null> | null, cartRow?: { __typename?: 'ProdottoNode' } | { __typename?: 'RigaCarrelloNode', pk?: number | null, quantita: number, omaggio: boolean, dataInizio?: any | null, garanzia: boolean, cmFirstIssue?: string | null, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, titolo?: string | null, mainImage?: string | null, tipologia?: string | null, tipo?: string | null, url?: string | null, codiceIva?: string | null, rinnovo?: boolean | null, prezzoScontato?: number | null, prezzo?: number | null, isbn?: string | null, isPrevendita?: boolean | null, disclaimerPrevendita?: string | null, garanzia?: { __typename?: 'GaranziaNode', nome?: string | null, descrizione?: string | null, prezzo?: number | null, durata: number } | null } | null } | { __typename?: 'RigaCheckoutNode' } | { __typename?: 'RigaWishlistNode' } | null } | null> | null, sistemaSpedizione?: { __typename?: 'PromotionalShippingType', total?: number | null, totalDiscounted?: number | null, percentageDiscount?: number | null, absoluteDiscount?: number | null, appliedPromotions?: Array<{ __typename?: 'AppliedPromotionType', promotion?: { __typename?: 'PromotionNode', pk?: number | null, name: string, promoCode?: string | null } | null } | null> | null } | null, appliedPromotions?: Array<{ __typename?: 'AppliedPromotionType', absoluteDiscount?: number | null, promotion?: { __typename?: 'PromotionNode', pk?: number | null, name: string, promoCode?: string | null, promoCoupon?: string | null } | null } | null> | null } | null };

export type FindIssuesQueryVariables = Exact<{
  riga: Scalars['Int'];
}>;


export type FindIssuesQuery = { __typename?: 'Query', findIssues: Array<{ __typename?: 'IssueType', cmIssue?: string | null, nominalIssueDate?: string | null, descriptionPeriod?: string | null } | null> };

export type AddItemMutationVariables = Exact<{
  item: Scalars['Int'];
  quantita: Scalars['Int'];
  garanzia: Scalars['Boolean'];
}>;


export type AddItemMutation = { __typename?: 'Mutation', addItem?: { __typename?: 'AddItem', status?: boolean | null, message?: string | null } | null };

export type AddAbbonamentoMutationVariables = Exact<{
  rivista: Scalars['Int'];
}>;


export type AddAbbonamentoMutation = { __typename?: 'Mutation', addAbbonamento?: { __typename?: 'AddAbbonamento', status?: boolean | null, message?: string | null } | null };

export type UpdateIssueMutationVariables = Exact<{
  issue: IssueInput;
  riga: Scalars['Int'];
}>;


export type UpdateIssueMutation = { __typename?: 'Mutation', updateIssue?: { __typename?: 'UpdateIssue', status?: boolean | null, message?: string | null } | null };

export type UpdateGaranziaMutationVariables = Exact<{
  garanzia: Scalars['Boolean'];
  riga: Scalars['Int'];
}>;


export type UpdateGaranziaMutation = { __typename?: 'Mutation', updateGaranzia?: { __typename?: 'UpdateGaranzia', status?: boolean | null, message?: string | null } | null };

export type RemoveItemMutationVariables = Exact<{
  item: Scalars['Int'];
}>;


export type RemoveItemMutation = { __typename?: 'Mutation', removeItem?: { __typename?: 'RemoveItem', status?: boolean | null, message?: string | null } | null };

export type SetPromoCodeMutationVariables = Exact<{
  promoCode: Scalars['String'];
}>;


export type SetPromoCodeMutation = { __typename?: 'Mutation', setPromoCode?: { __typename?: 'SetPromoCode', status?: boolean | null, message?: string | null } | null };

export type RemovePromoCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type RemovePromoCodeMutation = { __typename?: 'Mutation', removePromoCode?: { __typename?: 'RemovePromoCode', status?: boolean | null, message?: string | null } | null };

export type CheckoutQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckoutQuery = { __typename?: 'Query', checkout?: { __typename?: 'CheckoutType', totaleSenzaPromozioni?: number | null, scontoAssoluto?: number | null, totaleScontato?: number | null, scontoPercentuale?: number | null, totaleScontatoNetto?: number | null, totaleProdottiScontato?: number | null, totaleProdotti?: number | null, totaleServizi?: number | null, sistemaPagamento?: { __typename?: 'SistemaPagamentoType', pk?: number | null, alias: string } | null, sistemaSpedizione?: { __typename?: 'PromotionalShippingType', total?: number | null, totalDiscounted?: number | null, percentageDiscount?: number | null, absoluteDiscount?: number | null, appliedPromotions?: Array<{ __typename?: 'AppliedPromotionType', promotion?: { __typename?: 'PromotionNode', pk?: number | null, name: string, promoCode?: string | null, promoCoupon?: string | null } | null } | null> | null } | null, indirizzoSpedizione?: { __typename?: 'IndirizzoNode', pk?: number | null, nome?: string | null, cognome?: string | null, indirizzo?: string | null, civico?: string | null, informazioniAggiuntive?: string | null, telefono?: string | null, citta?: string | null, provincia?: string | null, cap?: string | null, cf?: string | null, privato: boolean } | null, indirizzoFatturazione?: { __typename?: 'IndirizzoNode', pk?: number | null, nome?: string | null, cognome?: string | null, ragioneSociale?: string | null, indirizzo?: string | null, civico?: string | null, informazioniAggiuntive?: string | null, telefono?: string | null, citta?: string | null, provincia?: string | null, cap?: string | null, cf?: string | null, piva?: string | null, sdi?: string | null, pec?: string | null, privato: boolean } | null, sistemiPagamento?: Array<{ __typename?: 'SistemaPagamentoType', pk?: number | null, alias: string, nome?: string | null, descrizione?: string | null, image?: string | null } | null> | null, items?: Array<{ __typename?: 'PromotionalItemType', total?: number | null, totalDiscounted?: number | null, percentageDiscount?: number | null, absoluteDiscount?: number | null, appliedPromotions?: Array<{ __typename?: 'AppliedPromotionType', promotion?: { __typename?: 'PromotionNode', pk?: number | null, name: string, promoCode?: string | null } | null } | null> | null, cartRow?: { __typename?: 'ProdottoNode' } | { __typename?: 'RigaCarrelloNode' } | { __typename?: 'RigaCheckoutNode', quantita: number, omaggio: boolean, dataInizio?: any | null, cmFirstIssue?: string | null, garanzia: boolean, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, tipo?: string | null, titolo?: string | null, tipologia?: string | null, mainImage?: string | null, url?: string | null, codiceIva?: string | null, rinnovo?: boolean | null, isbn?: string | null, isPrevendita?: boolean | null, disclaimerPrevendita?: string | null, garanzia?: { __typename?: 'GaranziaNode', nome?: string | null, descrizione?: string | null, prezzo?: number | null, durata: number } | null } | null } | { __typename?: 'RigaWishlistNode' } | null } | null> | null, appliedPromotions?: Array<{ __typename?: 'AppliedPromotionType', absoluteDiscount?: number | null, promotion?: { __typename?: 'PromotionNode', pk?: number | null, name: string, promoCode?: string | null, promoCoupon?: string | null } | null } | null> | null } | null };

export type SetCheckoutMutationVariables = Exact<{
  sistemaPagamento?: InputMaybe<Scalars['Int']>;
  codiceCartadeldocente?: InputMaybe<Scalars['String']>;
}>;


export type SetCheckoutMutation = { __typename?: 'Mutation', setCheckout?: { __typename?: 'SetCheckout', url?: string | null, status?: boolean | null, message?: string | null } | null };

export type SetIndirizziMutationVariables = Exact<{
  indirizzoSpedizione: Scalars['Int'];
  indirizzoFatturazione: Scalars['Int'];
}>;


export type SetIndirizziMutation = { __typename?: 'Mutation', setIndirizzi?: { __typename?: 'SetIndirizzi', status?: boolean | null, message?: string | null } | null };

export type IndirizziSpedizioneQueryVariables = Exact<{ [key: string]: never; }>;


export type IndirizziSpedizioneQuery = { __typename?: 'Query', indirizzi?: { __typename?: 'IndirizzoNodeConnection', edges: Array<{ __typename?: 'IndirizzoNodeEdge', node?: { __typename?: 'IndirizzoNode', pk?: number | null, nome?: string | null, cognome?: string | null, indirizzo?: string | null, civico?: string | null, informazioniAggiuntive?: string | null, telefono?: string | null, citta?: string | null, provincia?: string | null, cap?: string | null, cf?: string | null, default: boolean, isFatturazione: boolean, privato: boolean, apg: boolean } | null } | null> } | null };

export type IndirizziFatturazioneQueryVariables = Exact<{ [key: string]: never; }>;


export type IndirizziFatturazioneQuery = { __typename?: 'Query', indirizzi?: { __typename?: 'IndirizzoNodeConnection', edges: Array<{ __typename?: 'IndirizzoNodeEdge', node?: { __typename?: 'IndirizzoNode', pk?: number | null, nome?: string | null, cognome?: string | null, ragioneSociale?: string | null, indirizzo?: string | null, civico?: string | null, informazioniAggiuntive?: string | null, telefono?: string | null, citta?: string | null, provincia?: string | null, cap?: string | null, cf?: string | null, piva?: string | null, sdi?: string | null, pec?: string | null, privato: boolean, default: boolean, isFatturazione: boolean } | null } | null> } | null };

export type CreateIndirizzoMutationVariables = Exact<{
  input: IndirizzoInput;
}>;


export type CreateIndirizzoMutation = { __typename?: 'Mutation', createIndirizzo?: { __typename?: 'CreateIndirizzo', indirizzo?: { __typename?: 'IndirizzoNode', nome?: string | null, cognome?: string | null, indirizzo?: string | null, isFatturazione: boolean } | null } | null };

export type UpdateIndirizzoMutationVariables = Exact<{
  input: IndirizzoUpdateInput;
}>;


export type UpdateIndirizzoMutation = { __typename?: 'Mutation', updateIndirizzo?: { __typename?: 'UpdateIndirizzo', indirizzo?: { __typename?: 'IndirizzoNode', nome?: string | null, cognome?: string | null, isFatturazione: boolean } | null } | null };

export type DeleteIndirizzoMutationVariables = Exact<{
  input: IndirizzoDeleteInput;
}>;


export type DeleteIndirizzoMutation = { __typename?: 'Mutation', deleteIndirizzo?: { __typename?: 'DeleteIndirizzo', message?: string | null } | null };

export type SetDefaultIndirizzoMutationVariables = Exact<{
  input: IndirizzoSetDefaultInput;
}>;


export type SetDefaultIndirizzoMutation = { __typename?: 'Mutation', setDefaultIndirizzo?: { __typename?: 'SetDefaultIndirizzo', message?: string | null } | null };

export type DuplicateIndirizzoMutationVariables = Exact<{
  input: IndirizzoDuplicateInput;
}>;


export type DuplicateIndirizzoMutation = { __typename?: 'Mutation', duplicateIndirizzo?: { __typename?: 'DuplicateIndirizzo', indirizzo?: { __typename?: 'IndirizzoNode', pk?: number | null } | null } | null };

export type SetCartadeldocenteMutationVariables = Exact<{
  codiceVoucher: Scalars['String'];
}>;


export type SetCartadeldocenteMutation = { __typename?: 'Mutation', setCartadeldocente?: { __typename?: 'SetCartaDelDocente', status?: boolean | null, importo?: number | null } | null };

export type OrdineCheckoutQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdineCheckoutQuery = { __typename?: 'Query', ordineCheckout?: { __typename?: 'OrdineNode', pk?: number | null, costoSpedizione: number, impostaIva?: number | null, codiceCartadeldocente?: string | null, prezzoTotaleScontato: number, righeOrdineProdotti?: Array<{ __typename?: 'RigaOrdineNode', quantitaOrdinata: number, prezzoUnitarioScontato: number, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, titolo?: string | null, tipologia?: string | null, tipo?: string | null, quantita?: number | null, prezzoScontato?: number | null, prezzo?: number | null, isbn?: string | null } | null } | null> | null } | null };

export type OrdiniQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdiniQuery = { __typename?: 'Query', ordini?: { __typename?: 'OrdineNodeConnection', edges: Array<{ __typename?: 'OrdineNodeEdge', node?: { __typename?: 'OrdineNode', pk?: number | null, data?: string | null, prezzoTotaleScontato: number, prezzoTotaleServizi?: number | null, url?: string | null, annullabile?: boolean | null, statusReso?: string | null, etichettaReso?: string | null, rendibile?: boolean | null, trackingUrl?: string | null, stato?: { __typename?: 'StatoNode', nome: string, alias: string, chiave?: string | null } | null, righeOrdine?: Array<{ __typename?: 'RigaOrdineNode', pk?: number | null, quantitaOrdinata: number, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, mainImage?: string | null, rinnovo?: boolean | null } | null } | null> | null } | null } | null> } | null };

export type OrdineQueryVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type OrdineQuery = { __typename?: 'Query', ordine?: { __typename?: 'OrdineNode', pk?: number | null, data?: string | null, etichettaReso?: string | null, statusReso?: string | null, trackingUrl?: string | null, fatturaWeb?: string | null, costoSpedizione: number, prezzoTotale: number, prezzoTotaleScontato: number, totaleProdottiScontato: number, promoCode?: string | null, promozioneValoreAssoluto?: number | null, indirizzoSpedizione?: { __typename?: 'IndirizzoNode', nome?: string | null, cognome?: string | null, indirizzo?: string | null, civico?: string | null, cap?: string | null, citta?: string | null, provincia?: string | null } | null, indirizzoFatturazione?: { __typename?: 'IndirizzoNode', nome?: string | null, cognome?: string | null, indirizzo?: string | null, civico?: string | null, cap?: string | null, citta?: string | null, provincia?: string | null, cf?: string | null, piva?: string | null } | null, sistemaPagamento?: { __typename?: 'SistemaPagamentoType', nome?: string | null, image?: string | null } | null, stato?: { __typename?: 'StatoNode', nome: string, alias: string, chiave?: string | null } | null, righeOrdineProdotti?: Array<{ __typename?: 'RigaOrdineNode', pk?: number | null, quantitaOrdinata: number, prezzoUnitario: number, prezzoUnitarioScontato: number, prezzoTotaleScontato: number, omaggio: boolean, dataInizio?: any | null, quantitaResa: number, quantitaResoRichiesta?: number | null, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, titolo?: string | null, tipologia?: string | null, mainImage?: string | null, tipo?: string | null, rinnovo?: boolean | null, codiceIva?: string | null } | null } | null> | null, richiesteReso: Array<{ __typename?: 'RichiestaResoNode', data?: string | null, righeRichiestaReso: Array<{ __typename?: 'RigaRichiestaResoNode', quantitaResa?: number | null, quantitaRichiesta?: number | null, rigaOrdinePk?: number | null }> }> } | null };

export type OrdineResoQueryVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type OrdineResoQuery = { __typename?: 'Query', ordineReso?: { __typename?: 'OrdineNode', pk?: number | null, data?: string | null, righeOrdineProdotti?: Array<{ __typename?: 'RigaOrdineNode', pk?: number | null, quantitaOrdinata: number, prezzoUnitario: number, prezzoUnitarioScontato: number, prezzoTotaleScontato: number, omaggio: boolean, dataInizio?: any | null, quantitaResa: number, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, titolo?: string | null, tipologia?: string | null, mainImage?: string | null, tipo?: string | null, rinnovo?: boolean | null, codiceIva?: string | null } | null } | null> | null } | null };

export type AnnullaOrdineMutationVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type AnnullaOrdineMutation = { __typename?: 'Mutation', annullaOrdine?: { __typename?: 'AnnullaOrdine', status?: boolean | null, message?: string | null, order?: { __typename?: 'OrdineNode', annullabile?: boolean | null, stato?: { __typename?: 'StatoNode', nome: string, alias: string, chiave?: string | null } | null } | null } | null };

export type ProdottiAsBundleQueryVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type ProdottiAsBundleQuery = { __typename?: 'Query', prodottiAsBundle?: { __typename?: 'ProdottoNode', prodottiAsBundle?: Array<{ __typename?: 'PromotionalItemType', total?: number | null, totalDiscounted?: number | null, percentageDiscount?: number | null, absoluteDiscount?: number | null, appliedPromotions?: Array<{ __typename?: 'AppliedPromotionType', promotion?: { __typename?: 'PromotionNode', pk?: number | null, name: string, promoCode?: string | null } | null } | null> | null, cartRow?: { __typename?: 'ProdottoNode', pk?: number | null, titolo?: string | null, descrizione?: string | null, mainImage?: string | null, tipologia?: string | null, tipo?: string | null, url?: string | null, codiceIva?: string | null, rinnovo?: boolean | null, prezzoScontato?: number | null, prezzo?: number | null, isbn?: string | null, isPrevendita?: boolean | null, disclaimerPrevendita?: string | null, garanzia?: { __typename?: 'GaranziaNode', nome?: string | null, descrizione?: string | null, prezzo?: number | null, durata: number } | null, prodottiBundle?: Array<{ __typename?: 'PromotionalItemType', total?: number | null, totalDiscounted?: number | null, percentageDiscount?: number | null, absoluteDiscount?: number | null, appliedPromotions?: Array<{ __typename?: 'AppliedPromotionType', promotion?: { __typename?: 'PromotionNode', pk?: number | null, name: string, promoCode?: string | null } | null } | null> | null, cartRow?: { __typename?: 'ProdottoNode', pk?: number | null, titolo?: string | null, descrizione?: string | null, mainImage?: string | null, tooltipImage?: string | null, tipologia?: string | null, tipo?: string | null, url?: string | null, codiceIva?: string | null, rinnovo?: boolean | null, prezzoScontato?: number | null, prezzo?: number | null, isbn?: string | null, isPrevendita?: boolean | null, disclaimerPrevendita?: string | null } | { __typename?: 'RigaCarrelloNode' } | { __typename?: 'RigaCheckoutNode' } | { __typename?: 'RigaWishlistNode' } | null } | null> | null } | { __typename?: 'RigaCarrelloNode' } | { __typename?: 'RigaCheckoutNode' } | { __typename?: 'RigaWishlistNode' } | null } | null> | null } | null };

export type RichiediResoMutationVariables = Exact<{
  richiestaReso: RichiediResoInput;
}>;


export type RichiediResoMutation = { __typename?: 'Mutation', richiediReso?: { __typename?: 'RichiediReso', message?: string | null, status?: number | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UtenteNode', pk?: number | null, email: string, nome?: string | null, cognome?: string | null, isStaff: boolean } | null };

export type WishlistQueryVariables = Exact<{ [key: string]: never; }>;


export type WishlistQuery = { __typename?: 'Query', wishlist?: { __typename?: 'WishlistType', numProdotti?: number | null, items?: Array<{ __typename?: 'PromotionalItemType', total?: number | null, totalDiscounted?: number | null, cartRow?: { __typename?: 'ProdottoNode' } | { __typename?: 'RigaCarrelloNode' } | { __typename?: 'RigaCheckoutNode' } | { __typename?: 'RigaWishlistNode', pk?: number | null, quantita: number, omaggio: boolean, dataInizio?: any | null, cmFirstIssue?: string | null, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, titolo?: string | null, mainImage?: string | null, tipologia?: string | null, tipo?: string | null, url?: string | null, codiceIva?: string | null, rinnovo?: boolean | null, prezzoScontato?: number | null, prezzo?: number | null, isbn?: string | null, isPrevendita?: boolean | null, disclaimerPrevendita?: string | null } | null } | null } | null> | null } | null };


export const CartDocument = gql`
    query Cart {
  cart {
    items {
      total
      totalDiscounted
      percentageDiscount
      absoluteDiscount
      appliedPromotions {
        promotion {
          pk
          name
          promoCode
          promoCoupon
        }
      }
      cartRow {
        ... on RigaCarrelloNode {
          pk
          quantita
          omaggio
          dataInizio
          garanzia
          cmFirstIssue
          prodotto {
            pk
            titolo
            mainImage
            tipologia
            tipo
            url
            codiceIva
            rinnovo
            prezzoScontato
            prezzo
            tipologia
            isbn
            isPrevendita
            disclaimerPrevendita
            garanzia {
              nome
              descrizione
              prezzo
              durata
            }
          }
        }
      }
    }
    totaleScontato
    totaleProdottiScontato
    totaleProdotti
    totaleServizi
    scontoAssoluto
    scontoPercentuale
    numProdotti
    sistemaSpedizione {
      total
      totalDiscounted
      percentageDiscount
      absoluteDiscount
      appliedPromotions {
        promotion {
          pk
          name
          promoCode
        }
      }
    }
    appliedPromotions {
      promotion {
        pk
        name
        promoCode
        promoCoupon
      }
      absoluteDiscount
    }
  }
}
    `;

/**
 * __useCartQuery__
 *
 * To run a query within a React component, call `useCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartQuery(baseOptions?: Apollo.QueryHookOptions<CartQuery, CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartQuery, CartQueryVariables>(CartDocument, options);
      }
export function useCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export type CartQueryHookResult = ReturnType<typeof useCartQuery>;
export type CartLazyQueryHookResult = ReturnType<typeof useCartLazyQuery>;
export type CartQueryResult = Apollo.QueryResult<CartQuery, CartQueryVariables>;
export const FindIssuesDocument = gql`
    query FindIssues($riga: Int!) {
  findIssues(riga: $riga) {
    cmIssue
    nominalIssueDate
    descriptionPeriod
  }
}
    `;

/**
 * __useFindIssuesQuery__
 *
 * To run a query within a React component, call `useFindIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindIssuesQuery({
 *   variables: {
 *      riga: // value for 'riga'
 *   },
 * });
 */
export function useFindIssuesQuery(baseOptions: Apollo.QueryHookOptions<FindIssuesQuery, FindIssuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindIssuesQuery, FindIssuesQueryVariables>(FindIssuesDocument, options);
      }
export function useFindIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindIssuesQuery, FindIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindIssuesQuery, FindIssuesQueryVariables>(FindIssuesDocument, options);
        }
export type FindIssuesQueryHookResult = ReturnType<typeof useFindIssuesQuery>;
export type FindIssuesLazyQueryHookResult = ReturnType<typeof useFindIssuesLazyQuery>;
export type FindIssuesQueryResult = Apollo.QueryResult<FindIssuesQuery, FindIssuesQueryVariables>;
export const AddItemDocument = gql`
    mutation AddItem($item: Int!, $quantita: Int!, $garanzia: Boolean!) {
  addItem(item: $item, quantita: $quantita, garanzia: $garanzia) {
    status
    message
  }
}
    `;
export type AddItemMutationFn = Apollo.MutationFunction<AddItemMutation, AddItemMutationVariables>;

/**
 * __useAddItemMutation__
 *
 * To run a mutation, you first call `useAddItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemMutation, { data, loading, error }] = useAddItemMutation({
 *   variables: {
 *      item: // value for 'item'
 *      quantita: // value for 'quantita'
 *      garanzia: // value for 'garanzia'
 *   },
 * });
 */
export function useAddItemMutation(baseOptions?: Apollo.MutationHookOptions<AddItemMutation, AddItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemMutation, AddItemMutationVariables>(AddItemDocument, options);
      }
export type AddItemMutationHookResult = ReturnType<typeof useAddItemMutation>;
export type AddItemMutationResult = Apollo.MutationResult<AddItemMutation>;
export type AddItemMutationOptions = Apollo.BaseMutationOptions<AddItemMutation, AddItemMutationVariables>;
export const AddAbbonamentoDocument = gql`
    mutation AddAbbonamento($rivista: Int!) {
  addAbbonamento(rivista: $rivista) {
    status
    message
  }
}
    `;
export type AddAbbonamentoMutationFn = Apollo.MutationFunction<AddAbbonamentoMutation, AddAbbonamentoMutationVariables>;

/**
 * __useAddAbbonamentoMutation__
 *
 * To run a mutation, you first call `useAddAbbonamentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAbbonamentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAbbonamentoMutation, { data, loading, error }] = useAddAbbonamentoMutation({
 *   variables: {
 *      rivista: // value for 'rivista'
 *   },
 * });
 */
export function useAddAbbonamentoMutation(baseOptions?: Apollo.MutationHookOptions<AddAbbonamentoMutation, AddAbbonamentoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAbbonamentoMutation, AddAbbonamentoMutationVariables>(AddAbbonamentoDocument, options);
      }
export type AddAbbonamentoMutationHookResult = ReturnType<typeof useAddAbbonamentoMutation>;
export type AddAbbonamentoMutationResult = Apollo.MutationResult<AddAbbonamentoMutation>;
export type AddAbbonamentoMutationOptions = Apollo.BaseMutationOptions<AddAbbonamentoMutation, AddAbbonamentoMutationVariables>;
export const UpdateIssueDocument = gql`
    mutation UpdateIssue($issue: IssueInput!, $riga: Int!) {
  updateIssue(issue: $issue, riga: $riga) {
    status
    message
  }
}
    `;
export type UpdateIssueMutationFn = Apollo.MutationFunction<UpdateIssueMutation, UpdateIssueMutationVariables>;

/**
 * __useUpdateIssueMutation__
 *
 * To run a mutation, you first call `useUpdateIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIssueMutation, { data, loading, error }] = useUpdateIssueMutation({
 *   variables: {
 *      issue: // value for 'issue'
 *      riga: // value for 'riga'
 *   },
 * });
 */
export function useUpdateIssueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIssueMutation, UpdateIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIssueMutation, UpdateIssueMutationVariables>(UpdateIssueDocument, options);
      }
export type UpdateIssueMutationHookResult = ReturnType<typeof useUpdateIssueMutation>;
export type UpdateIssueMutationResult = Apollo.MutationResult<UpdateIssueMutation>;
export type UpdateIssueMutationOptions = Apollo.BaseMutationOptions<UpdateIssueMutation, UpdateIssueMutationVariables>;
export const UpdateGaranziaDocument = gql`
    mutation UpdateGaranzia($garanzia: Boolean!, $riga: Int!) {
  updateGaranzia(garanzia: $garanzia, riga: $riga) {
    status
    message
  }
}
    `;
export type UpdateGaranziaMutationFn = Apollo.MutationFunction<UpdateGaranziaMutation, UpdateGaranziaMutationVariables>;

/**
 * __useUpdateGaranziaMutation__
 *
 * To run a mutation, you first call `useUpdateGaranziaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGaranziaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGaranziaMutation, { data, loading, error }] = useUpdateGaranziaMutation({
 *   variables: {
 *      garanzia: // value for 'garanzia'
 *      riga: // value for 'riga'
 *   },
 * });
 */
export function useUpdateGaranziaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGaranziaMutation, UpdateGaranziaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGaranziaMutation, UpdateGaranziaMutationVariables>(UpdateGaranziaDocument, options);
      }
export type UpdateGaranziaMutationHookResult = ReturnType<typeof useUpdateGaranziaMutation>;
export type UpdateGaranziaMutationResult = Apollo.MutationResult<UpdateGaranziaMutation>;
export type UpdateGaranziaMutationOptions = Apollo.BaseMutationOptions<UpdateGaranziaMutation, UpdateGaranziaMutationVariables>;
export const RemoveItemDocument = gql`
    mutation RemoveItem($item: Int!) {
  removeItem(item: $item) {
    status
    message
  }
}
    `;
export type RemoveItemMutationFn = Apollo.MutationFunction<RemoveItemMutation, RemoveItemMutationVariables>;

/**
 * __useRemoveItemMutation__
 *
 * To run a mutation, you first call `useRemoveItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemMutation, { data, loading, error }] = useRemoveItemMutation({
 *   variables: {
 *      item: // value for 'item'
 *   },
 * });
 */
export function useRemoveItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveItemMutation, RemoveItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveItemMutation, RemoveItemMutationVariables>(RemoveItemDocument, options);
      }
export type RemoveItemMutationHookResult = ReturnType<typeof useRemoveItemMutation>;
export type RemoveItemMutationResult = Apollo.MutationResult<RemoveItemMutation>;
export type RemoveItemMutationOptions = Apollo.BaseMutationOptions<RemoveItemMutation, RemoveItemMutationVariables>;
export const SetPromoCodeDocument = gql`
    mutation SetPromoCode($promoCode: String!) {
  setPromoCode(promoCode: $promoCode) {
    status
    message
  }
}
    `;
export type SetPromoCodeMutationFn = Apollo.MutationFunction<SetPromoCodeMutation, SetPromoCodeMutationVariables>;

/**
 * __useSetPromoCodeMutation__
 *
 * To run a mutation, you first call `useSetPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPromoCodeMutation, { data, loading, error }] = useSetPromoCodeMutation({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useSetPromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<SetPromoCodeMutation, SetPromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPromoCodeMutation, SetPromoCodeMutationVariables>(SetPromoCodeDocument, options);
      }
export type SetPromoCodeMutationHookResult = ReturnType<typeof useSetPromoCodeMutation>;
export type SetPromoCodeMutationResult = Apollo.MutationResult<SetPromoCodeMutation>;
export type SetPromoCodeMutationOptions = Apollo.BaseMutationOptions<SetPromoCodeMutation, SetPromoCodeMutationVariables>;
export const RemovePromoCodeDocument = gql`
    mutation RemovePromoCode {
  removePromoCode {
    status
    message
  }
}
    `;
export type RemovePromoCodeMutationFn = Apollo.MutationFunction<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>;

/**
 * __useRemovePromoCodeMutation__
 *
 * To run a mutation, you first call `useRemovePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePromoCodeMutation, { data, loading, error }] = useRemovePromoCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemovePromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>(RemovePromoCodeDocument, options);
      }
export type RemovePromoCodeMutationHookResult = ReturnType<typeof useRemovePromoCodeMutation>;
export type RemovePromoCodeMutationResult = Apollo.MutationResult<RemovePromoCodeMutation>;
export type RemovePromoCodeMutationOptions = Apollo.BaseMutationOptions<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>;
export const CheckoutDocument = gql`
    query Checkout {
  checkout {
    sistemaPagamento {
      pk
      alias
    }
    sistemaSpedizione {
      total
      totalDiscounted
      percentageDiscount
      absoluteDiscount
      appliedPromotions {
        promotion {
          pk
          name
          promoCode
          promoCoupon
        }
      }
    }
    indirizzoSpedizione {
      pk
      nome
      cognome
      indirizzo
      civico
      informazioniAggiuntive
      telefono
      citta
      provincia
      cap
      cf
      privato
    }
    indirizzoFatturazione {
      pk
      nome
      cognome
      ragioneSociale
      indirizzo
      civico
      informazioniAggiuntive
      telefono
      citta
      provincia
      cap
      cf
      piva
      sdi
      pec
      privato
    }
    totaleSenzaPromozioni
    scontoAssoluto
    totaleScontato
    scontoPercentuale
    totaleScontatoNetto
    totaleProdottiScontato
    totaleProdotti
    totaleServizi
    sistemiPagamento {
      pk
      alias
      nome
      descrizione
      image
    }
    items {
      total
      totalDiscounted
      percentageDiscount
      absoluteDiscount
      appliedPromotions {
        promotion {
          pk
          name
          promoCode
        }
      }
      cartRow {
        ... on RigaCheckoutNode {
          quantita
          omaggio
          dataInizio
          cmFirstIssue
          garanzia
          prodotto {
            pk
            tipo
            titolo
            tipologia
            mainImage
            url
            codiceIva
            rinnovo
            isbn
            isPrevendita
            disclaimerPrevendita
            garanzia {
              nome
              descrizione
              prezzo
              durata
            }
          }
        }
      }
    }
    appliedPromotions {
      promotion {
        pk
        name
        promoCode
        promoCoupon
      }
      absoluteDiscount
    }
  }
}
    `;

/**
 * __useCheckoutQuery__
 *
 * To run a query within a React component, call `useCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckoutQuery(baseOptions?: Apollo.QueryHookOptions<CheckoutQuery, CheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutQuery, CheckoutQueryVariables>(CheckoutDocument, options);
      }
export function useCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutQuery, CheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutQuery, CheckoutQueryVariables>(CheckoutDocument, options);
        }
export type CheckoutQueryHookResult = ReturnType<typeof useCheckoutQuery>;
export type CheckoutLazyQueryHookResult = ReturnType<typeof useCheckoutLazyQuery>;
export type CheckoutQueryResult = Apollo.QueryResult<CheckoutQuery, CheckoutQueryVariables>;
export const SetCheckoutDocument = gql`
    mutation SetCheckout($sistemaPagamento: Int, $codiceCartadeldocente: String) {
  setCheckout(
    sistemaPagamento: $sistemaPagamento
    codiceCartadeldocente: $codiceCartadeldocente
  ) {
    url
    status
    message
  }
}
    `;
export type SetCheckoutMutationFn = Apollo.MutationFunction<SetCheckoutMutation, SetCheckoutMutationVariables>;

/**
 * __useSetCheckoutMutation__
 *
 * To run a mutation, you first call `useSetCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCheckoutMutation, { data, loading, error }] = useSetCheckoutMutation({
 *   variables: {
 *      sistemaPagamento: // value for 'sistemaPagamento'
 *      codiceCartadeldocente: // value for 'codiceCartadeldocente'
 *   },
 * });
 */
export function useSetCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<SetCheckoutMutation, SetCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCheckoutMutation, SetCheckoutMutationVariables>(SetCheckoutDocument, options);
      }
export type SetCheckoutMutationHookResult = ReturnType<typeof useSetCheckoutMutation>;
export type SetCheckoutMutationResult = Apollo.MutationResult<SetCheckoutMutation>;
export type SetCheckoutMutationOptions = Apollo.BaseMutationOptions<SetCheckoutMutation, SetCheckoutMutationVariables>;
export const SetIndirizziDocument = gql`
    mutation SetIndirizzi($indirizzoSpedizione: Int!, $indirizzoFatturazione: Int!) {
  setIndirizzi(
    indirizzoSpedizione: $indirizzoSpedizione
    indirizzoFatturazione: $indirizzoFatturazione
  ) {
    status
    message
  }
}
    `;
export type SetIndirizziMutationFn = Apollo.MutationFunction<SetIndirizziMutation, SetIndirizziMutationVariables>;

/**
 * __useSetIndirizziMutation__
 *
 * To run a mutation, you first call `useSetIndirizziMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIndirizziMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIndirizziMutation, { data, loading, error }] = useSetIndirizziMutation({
 *   variables: {
 *      indirizzoSpedizione: // value for 'indirizzoSpedizione'
 *      indirizzoFatturazione: // value for 'indirizzoFatturazione'
 *   },
 * });
 */
export function useSetIndirizziMutation(baseOptions?: Apollo.MutationHookOptions<SetIndirizziMutation, SetIndirizziMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIndirizziMutation, SetIndirizziMutationVariables>(SetIndirizziDocument, options);
      }
export type SetIndirizziMutationHookResult = ReturnType<typeof useSetIndirizziMutation>;
export type SetIndirizziMutationResult = Apollo.MutationResult<SetIndirizziMutation>;
export type SetIndirizziMutationOptions = Apollo.BaseMutationOptions<SetIndirizziMutation, SetIndirizziMutationVariables>;
export const IndirizziSpedizioneDocument = gql`
    query IndirizziSpedizione {
  indirizzi(isFatturazione: false) {
    edges {
      node {
        pk
        nome
        cognome
        indirizzo
        civico
        informazioniAggiuntive
        telefono
        citta
        provincia
        cap
        cf
        default
        isFatturazione
        privato
        apg
      }
    }
  }
}
    `;

/**
 * __useIndirizziSpedizioneQuery__
 *
 * To run a query within a React component, call `useIndirizziSpedizioneQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndirizziSpedizioneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndirizziSpedizioneQuery({
 *   variables: {
 *   },
 * });
 */
export function useIndirizziSpedizioneQuery(baseOptions?: Apollo.QueryHookOptions<IndirizziSpedizioneQuery, IndirizziSpedizioneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndirizziSpedizioneQuery, IndirizziSpedizioneQueryVariables>(IndirizziSpedizioneDocument, options);
      }
export function useIndirizziSpedizioneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndirizziSpedizioneQuery, IndirizziSpedizioneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndirizziSpedizioneQuery, IndirizziSpedizioneQueryVariables>(IndirizziSpedizioneDocument, options);
        }
export type IndirizziSpedizioneQueryHookResult = ReturnType<typeof useIndirizziSpedizioneQuery>;
export type IndirizziSpedizioneLazyQueryHookResult = ReturnType<typeof useIndirizziSpedizioneLazyQuery>;
export type IndirizziSpedizioneQueryResult = Apollo.QueryResult<IndirizziSpedizioneQuery, IndirizziSpedizioneQueryVariables>;
export const IndirizziFatturazioneDocument = gql`
    query IndirizziFatturazione {
  indirizzi(isFatturazione: true) {
    edges {
      node {
        pk
        nome
        cognome
        ragioneSociale
        indirizzo
        civico
        informazioniAggiuntive
        telefono
        citta
        provincia
        cap
        cf
        piva
        sdi
        pec
        privato
        default
        isFatturazione
      }
    }
  }
}
    `;

/**
 * __useIndirizziFatturazioneQuery__
 *
 * To run a query within a React component, call `useIndirizziFatturazioneQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndirizziFatturazioneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndirizziFatturazioneQuery({
 *   variables: {
 *   },
 * });
 */
export function useIndirizziFatturazioneQuery(baseOptions?: Apollo.QueryHookOptions<IndirizziFatturazioneQuery, IndirizziFatturazioneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndirizziFatturazioneQuery, IndirizziFatturazioneQueryVariables>(IndirizziFatturazioneDocument, options);
      }
export function useIndirizziFatturazioneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndirizziFatturazioneQuery, IndirizziFatturazioneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndirizziFatturazioneQuery, IndirizziFatturazioneQueryVariables>(IndirizziFatturazioneDocument, options);
        }
export type IndirizziFatturazioneQueryHookResult = ReturnType<typeof useIndirizziFatturazioneQuery>;
export type IndirizziFatturazioneLazyQueryHookResult = ReturnType<typeof useIndirizziFatturazioneLazyQuery>;
export type IndirizziFatturazioneQueryResult = Apollo.QueryResult<IndirizziFatturazioneQuery, IndirizziFatturazioneQueryVariables>;
export const CreateIndirizzoDocument = gql`
    mutation CreateIndirizzo($input: IndirizzoInput!) {
  createIndirizzo(input: $input) {
    indirizzo {
      nome
      cognome
      indirizzo
      isFatturazione
    }
  }
}
    `;
export type CreateIndirizzoMutationFn = Apollo.MutationFunction<CreateIndirizzoMutation, CreateIndirizzoMutationVariables>;

/**
 * __useCreateIndirizzoMutation__
 *
 * To run a mutation, you first call `useCreateIndirizzoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndirizzoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndirizzoMutation, { data, loading, error }] = useCreateIndirizzoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIndirizzoMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndirizzoMutation, CreateIndirizzoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndirizzoMutation, CreateIndirizzoMutationVariables>(CreateIndirizzoDocument, options);
      }
export type CreateIndirizzoMutationHookResult = ReturnType<typeof useCreateIndirizzoMutation>;
export type CreateIndirizzoMutationResult = Apollo.MutationResult<CreateIndirizzoMutation>;
export type CreateIndirizzoMutationOptions = Apollo.BaseMutationOptions<CreateIndirizzoMutation, CreateIndirizzoMutationVariables>;
export const UpdateIndirizzoDocument = gql`
    mutation UpdateIndirizzo($input: IndirizzoUpdateInput!) {
  updateIndirizzo(input: $input) {
    indirizzo {
      nome
      cognome
      isFatturazione
    }
  }
}
    `;
export type UpdateIndirizzoMutationFn = Apollo.MutationFunction<UpdateIndirizzoMutation, UpdateIndirizzoMutationVariables>;

/**
 * __useUpdateIndirizzoMutation__
 *
 * To run a mutation, you first call `useUpdateIndirizzoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndirizzoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndirizzoMutation, { data, loading, error }] = useUpdateIndirizzoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIndirizzoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndirizzoMutation, UpdateIndirizzoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndirizzoMutation, UpdateIndirizzoMutationVariables>(UpdateIndirizzoDocument, options);
      }
export type UpdateIndirizzoMutationHookResult = ReturnType<typeof useUpdateIndirizzoMutation>;
export type UpdateIndirizzoMutationResult = Apollo.MutationResult<UpdateIndirizzoMutation>;
export type UpdateIndirizzoMutationOptions = Apollo.BaseMutationOptions<UpdateIndirizzoMutation, UpdateIndirizzoMutationVariables>;
export const DeleteIndirizzoDocument = gql`
    mutation DeleteIndirizzo($input: IndirizzoDeleteInput!) {
  deleteIndirizzo(input: $input) {
    message
  }
}
    `;
export type DeleteIndirizzoMutationFn = Apollo.MutationFunction<DeleteIndirizzoMutation, DeleteIndirizzoMutationVariables>;

/**
 * __useDeleteIndirizzoMutation__
 *
 * To run a mutation, you first call `useDeleteIndirizzoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndirizzoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndirizzoMutation, { data, loading, error }] = useDeleteIndirizzoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIndirizzoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIndirizzoMutation, DeleteIndirizzoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIndirizzoMutation, DeleteIndirizzoMutationVariables>(DeleteIndirizzoDocument, options);
      }
export type DeleteIndirizzoMutationHookResult = ReturnType<typeof useDeleteIndirizzoMutation>;
export type DeleteIndirizzoMutationResult = Apollo.MutationResult<DeleteIndirizzoMutation>;
export type DeleteIndirizzoMutationOptions = Apollo.BaseMutationOptions<DeleteIndirizzoMutation, DeleteIndirizzoMutationVariables>;
export const SetDefaultIndirizzoDocument = gql`
    mutation SetDefaultIndirizzo($input: IndirizzoSetDefaultInput!) {
  setDefaultIndirizzo(input: $input) {
    message
  }
}
    `;
export type SetDefaultIndirizzoMutationFn = Apollo.MutationFunction<SetDefaultIndirizzoMutation, SetDefaultIndirizzoMutationVariables>;

/**
 * __useSetDefaultIndirizzoMutation__
 *
 * To run a mutation, you first call `useSetDefaultIndirizzoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultIndirizzoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultIndirizzoMutation, { data, loading, error }] = useSetDefaultIndirizzoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDefaultIndirizzoMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultIndirizzoMutation, SetDefaultIndirizzoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultIndirizzoMutation, SetDefaultIndirizzoMutationVariables>(SetDefaultIndirizzoDocument, options);
      }
export type SetDefaultIndirizzoMutationHookResult = ReturnType<typeof useSetDefaultIndirizzoMutation>;
export type SetDefaultIndirizzoMutationResult = Apollo.MutationResult<SetDefaultIndirizzoMutation>;
export type SetDefaultIndirizzoMutationOptions = Apollo.BaseMutationOptions<SetDefaultIndirizzoMutation, SetDefaultIndirizzoMutationVariables>;
export const DuplicateIndirizzoDocument = gql`
    mutation DuplicateIndirizzo($input: IndirizzoDuplicateInput!) {
  duplicateIndirizzo(input: $input) {
    indirizzo {
      pk
    }
  }
}
    `;
export type DuplicateIndirizzoMutationFn = Apollo.MutationFunction<DuplicateIndirizzoMutation, DuplicateIndirizzoMutationVariables>;

/**
 * __useDuplicateIndirizzoMutation__
 *
 * To run a mutation, you first call `useDuplicateIndirizzoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateIndirizzoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateIndirizzoMutation, { data, loading, error }] = useDuplicateIndirizzoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateIndirizzoMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateIndirizzoMutation, DuplicateIndirizzoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateIndirizzoMutation, DuplicateIndirizzoMutationVariables>(DuplicateIndirizzoDocument, options);
      }
export type DuplicateIndirizzoMutationHookResult = ReturnType<typeof useDuplicateIndirizzoMutation>;
export type DuplicateIndirizzoMutationResult = Apollo.MutationResult<DuplicateIndirizzoMutation>;
export type DuplicateIndirizzoMutationOptions = Apollo.BaseMutationOptions<DuplicateIndirizzoMutation, DuplicateIndirizzoMutationVariables>;
export const SetCartadeldocenteDocument = gql`
    mutation SetCartadeldocente($codiceVoucher: String!) {
  setCartadeldocente(codiceVoucher: $codiceVoucher) {
    status
    importo
  }
}
    `;
export type SetCartadeldocenteMutationFn = Apollo.MutationFunction<SetCartadeldocenteMutation, SetCartadeldocenteMutationVariables>;

/**
 * __useSetCartadeldocenteMutation__
 *
 * To run a mutation, you first call `useSetCartadeldocenteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCartadeldocenteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCartadeldocenteMutation, { data, loading, error }] = useSetCartadeldocenteMutation({
 *   variables: {
 *      codiceVoucher: // value for 'codiceVoucher'
 *   },
 * });
 */
export function useSetCartadeldocenteMutation(baseOptions?: Apollo.MutationHookOptions<SetCartadeldocenteMutation, SetCartadeldocenteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCartadeldocenteMutation, SetCartadeldocenteMutationVariables>(SetCartadeldocenteDocument, options);
      }
export type SetCartadeldocenteMutationHookResult = ReturnType<typeof useSetCartadeldocenteMutation>;
export type SetCartadeldocenteMutationResult = Apollo.MutationResult<SetCartadeldocenteMutation>;
export type SetCartadeldocenteMutationOptions = Apollo.BaseMutationOptions<SetCartadeldocenteMutation, SetCartadeldocenteMutationVariables>;
export const OrdineCheckoutDocument = gql`
    query OrdineCheckout {
  ordineCheckout {
    pk
    costoSpedizione
    impostaIva
    codiceCartadeldocente
    prezzoTotaleScontato
    righeOrdineProdotti {
      quantitaOrdinata
      prezzoUnitarioScontato
      prodotto {
        pk
        titolo
        tipologia
        tipo
        quantita
        prezzoScontato
        prezzo
        isbn
      }
    }
  }
}
    `;

/**
 * __useOrdineCheckoutQuery__
 *
 * To run a query within a React component, call `useOrdineCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdineCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdineCheckoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrdineCheckoutQuery(baseOptions?: Apollo.QueryHookOptions<OrdineCheckoutQuery, OrdineCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdineCheckoutQuery, OrdineCheckoutQueryVariables>(OrdineCheckoutDocument, options);
      }
export function useOrdineCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdineCheckoutQuery, OrdineCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdineCheckoutQuery, OrdineCheckoutQueryVariables>(OrdineCheckoutDocument, options);
        }
export type OrdineCheckoutQueryHookResult = ReturnType<typeof useOrdineCheckoutQuery>;
export type OrdineCheckoutLazyQueryHookResult = ReturnType<typeof useOrdineCheckoutLazyQuery>;
export type OrdineCheckoutQueryResult = Apollo.QueryResult<OrdineCheckoutQuery, OrdineCheckoutQueryVariables>;
export const OrdiniDocument = gql`
    query Ordini {
  ordini {
    edges {
      node {
        pk
        data
        prezzoTotaleScontato
        prezzoTotaleServizi
        url
        annullabile
        statusReso
        etichettaReso
        rendibile
        trackingUrl
        stato {
          nome
          alias
          chiave
        }
        righeOrdine {
          pk
          quantitaOrdinata
          prodotto {
            pk
            mainImage
            rinnovo
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrdiniQuery__
 *
 * To run a query within a React component, call `useOrdiniQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdiniQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdiniQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrdiniQuery(baseOptions?: Apollo.QueryHookOptions<OrdiniQuery, OrdiniQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdiniQuery, OrdiniQueryVariables>(OrdiniDocument, options);
      }
export function useOrdiniLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdiniQuery, OrdiniQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdiniQuery, OrdiniQueryVariables>(OrdiniDocument, options);
        }
export type OrdiniQueryHookResult = ReturnType<typeof useOrdiniQuery>;
export type OrdiniLazyQueryHookResult = ReturnType<typeof useOrdiniLazyQuery>;
export type OrdiniQueryResult = Apollo.QueryResult<OrdiniQuery, OrdiniQueryVariables>;
export const OrdineDocument = gql`
    query Ordine($pk: Int!) {
  ordine(pk: $pk) {
    pk
    data
    etichettaReso
    statusReso
    trackingUrl
    fatturaWeb
    costoSpedizione
    indirizzoSpedizione {
      nome
      cognome
      indirizzo
      civico
      cap
      citta
      provincia
    }
    indirizzoFatturazione {
      nome
      cognome
      indirizzo
      civico
      cap
      citta
      provincia
      cf
      piva
    }
    sistemaPagamento {
      nome
      image
    }
    stato {
      nome
      alias
      chiave
    }
    prezzoTotale
    prezzoTotaleScontato
    totaleProdottiScontato
    righeOrdineProdotti {
      pk
      quantitaOrdinata
      prezzoUnitario
      prezzoUnitarioScontato
      prezzoTotaleScontato
      omaggio
      dataInizio
      quantitaResa
      quantitaResoRichiesta
      prodotto {
        pk
        titolo
        tipologia
        mainImage
        tipo
        rinnovo
        codiceIva
      }
    }
    promoCode
    promozioneValoreAssoluto
    richiesteReso {
      data
      righeRichiestaReso {
        quantitaResa
        quantitaRichiesta
        rigaOrdinePk
      }
    }
  }
}
    `;

/**
 * __useOrdineQuery__
 *
 * To run a query within a React component, call `useOrdineQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdineQuery({
 *   variables: {
 *      pk: // value for 'pk'
 *   },
 * });
 */
export function useOrdineQuery(baseOptions: Apollo.QueryHookOptions<OrdineQuery, OrdineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdineQuery, OrdineQueryVariables>(OrdineDocument, options);
      }
export function useOrdineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdineQuery, OrdineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdineQuery, OrdineQueryVariables>(OrdineDocument, options);
        }
export type OrdineQueryHookResult = ReturnType<typeof useOrdineQuery>;
export type OrdineLazyQueryHookResult = ReturnType<typeof useOrdineLazyQuery>;
export type OrdineQueryResult = Apollo.QueryResult<OrdineQuery, OrdineQueryVariables>;
export const OrdineResoDocument = gql`
    query OrdineReso($pk: Int!) {
  ordineReso(pk: $pk) {
    pk
    data
    righeOrdineProdotti {
      pk
      quantitaOrdinata
      prezzoUnitario
      prezzoUnitarioScontato
      prezzoTotaleScontato
      omaggio
      dataInizio
      quantitaResa
      prodotto {
        pk
        titolo
        tipologia
        mainImage
        tipo
        rinnovo
        codiceIva
      }
    }
  }
}
    `;

/**
 * __useOrdineResoQuery__
 *
 * To run a query within a React component, call `useOrdineResoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdineResoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdineResoQuery({
 *   variables: {
 *      pk: // value for 'pk'
 *   },
 * });
 */
export function useOrdineResoQuery(baseOptions: Apollo.QueryHookOptions<OrdineResoQuery, OrdineResoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdineResoQuery, OrdineResoQueryVariables>(OrdineResoDocument, options);
      }
export function useOrdineResoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdineResoQuery, OrdineResoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdineResoQuery, OrdineResoQueryVariables>(OrdineResoDocument, options);
        }
export type OrdineResoQueryHookResult = ReturnType<typeof useOrdineResoQuery>;
export type OrdineResoLazyQueryHookResult = ReturnType<typeof useOrdineResoLazyQuery>;
export type OrdineResoQueryResult = Apollo.QueryResult<OrdineResoQuery, OrdineResoQueryVariables>;
export const AnnullaOrdineDocument = gql`
    mutation AnnullaOrdine($orderId: Int!) {
  annullaOrdine(orderId: $orderId) {
    status
    message
    order {
      annullabile
      stato {
        nome
        alias
        chiave
      }
    }
  }
}
    `;
export type AnnullaOrdineMutationFn = Apollo.MutationFunction<AnnullaOrdineMutation, AnnullaOrdineMutationVariables>;

/**
 * __useAnnullaOrdineMutation__
 *
 * To run a mutation, you first call `useAnnullaOrdineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnullaOrdineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [annullaOrdineMutation, { data, loading, error }] = useAnnullaOrdineMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAnnullaOrdineMutation(baseOptions?: Apollo.MutationHookOptions<AnnullaOrdineMutation, AnnullaOrdineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnnullaOrdineMutation, AnnullaOrdineMutationVariables>(AnnullaOrdineDocument, options);
      }
export type AnnullaOrdineMutationHookResult = ReturnType<typeof useAnnullaOrdineMutation>;
export type AnnullaOrdineMutationResult = Apollo.MutationResult<AnnullaOrdineMutation>;
export type AnnullaOrdineMutationOptions = Apollo.BaseMutationOptions<AnnullaOrdineMutation, AnnullaOrdineMutationVariables>;
export const ProdottiAsBundleDocument = gql`
    query ProdottiAsBundle($pk: Int!) {
  prodottiAsBundle(pk: $pk) {
    prodottiAsBundle {
      total
      totalDiscounted
      percentageDiscount
      absoluteDiscount
      appliedPromotions {
        promotion {
          pk
          name
          promoCode
        }
      }
      cartRow {
        ... on ProdottoNode {
          pk
          titolo
          descrizione
          mainImage
          tipologia
          tipo
          url
          codiceIva
          rinnovo
          prezzoScontato
          prezzo
          tipologia
          isbn
          isPrevendita
          disclaimerPrevendita
          garanzia {
            nome
            descrizione
            prezzo
            durata
          }
          prodottiBundle {
            total
            totalDiscounted
            percentageDiscount
            absoluteDiscount
            appliedPromotions {
              promotion {
                pk
                name
                promoCode
              }
            }
            cartRow {
              ... on ProdottoNode {
                pk
                titolo
                descrizione
                mainImage
                tooltipImage
                tipologia
                tipo
                url
                codiceIva
                rinnovo
                prezzoScontato
                prezzo
                tipologia
                isbn
                isPrevendita
                disclaimerPrevendita
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProdottiAsBundleQuery__
 *
 * To run a query within a React component, call `useProdottiAsBundleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProdottiAsBundleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProdottiAsBundleQuery({
 *   variables: {
 *      pk: // value for 'pk'
 *   },
 * });
 */
export function useProdottiAsBundleQuery(baseOptions: Apollo.QueryHookOptions<ProdottiAsBundleQuery, ProdottiAsBundleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProdottiAsBundleQuery, ProdottiAsBundleQueryVariables>(ProdottiAsBundleDocument, options);
      }
export function useProdottiAsBundleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProdottiAsBundleQuery, ProdottiAsBundleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProdottiAsBundleQuery, ProdottiAsBundleQueryVariables>(ProdottiAsBundleDocument, options);
        }
export type ProdottiAsBundleQueryHookResult = ReturnType<typeof useProdottiAsBundleQuery>;
export type ProdottiAsBundleLazyQueryHookResult = ReturnType<typeof useProdottiAsBundleLazyQuery>;
export type ProdottiAsBundleQueryResult = Apollo.QueryResult<ProdottiAsBundleQuery, ProdottiAsBundleQueryVariables>;
export const RichiediResoDocument = gql`
    mutation RichiediReso($richiestaReso: RichiediResoInput!) {
  richiediReso(richiestaReso: $richiestaReso) {
    message
    status
  }
}
    `;
export type RichiediResoMutationFn = Apollo.MutationFunction<RichiediResoMutation, RichiediResoMutationVariables>;

/**
 * __useRichiediResoMutation__
 *
 * To run a mutation, you first call `useRichiediResoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRichiediResoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [richiediResoMutation, { data, loading, error }] = useRichiediResoMutation({
 *   variables: {
 *      richiestaReso: // value for 'richiestaReso'
 *   },
 * });
 */
export function useRichiediResoMutation(baseOptions?: Apollo.MutationHookOptions<RichiediResoMutation, RichiediResoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RichiediResoMutation, RichiediResoMutationVariables>(RichiediResoDocument, options);
      }
export type RichiediResoMutationHookResult = ReturnType<typeof useRichiediResoMutation>;
export type RichiediResoMutationResult = Apollo.MutationResult<RichiediResoMutation>;
export type RichiediResoMutationOptions = Apollo.BaseMutationOptions<RichiediResoMutation, RichiediResoMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    pk
    email
    nome
    cognome
    isStaff
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const WishlistDocument = gql`
    query Wishlist {
  wishlist {
    numProdotti
    items {
      total
      totalDiscounted
      cartRow {
        ... on RigaWishlistNode {
          pk
          quantita
          omaggio
          dataInizio
          cmFirstIssue
          prodotto {
            pk
            titolo
            mainImage
            tipologia
            tipo
            url
            codiceIva
            rinnovo
            prezzoScontato
            prezzo
            tipologia
            isbn
            isPrevendita
            disclaimerPrevendita
          }
        }
      }
    }
  }
}
    `;

/**
 * __useWishlistQuery__
 *
 * To run a query within a React component, call `useWishlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWishlistQuery({
 *   variables: {
 *   },
 * });
 */
export function useWishlistQuery(baseOptions?: Apollo.QueryHookOptions<WishlistQuery, WishlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WishlistQuery, WishlistQueryVariables>(WishlistDocument, options);
      }
export function useWishlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WishlistQuery, WishlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WishlistQuery, WishlistQueryVariables>(WishlistDocument, options);
        }
export type WishlistQueryHookResult = ReturnType<typeof useWishlistQuery>;
export type WishlistLazyQueryHookResult = ReturnType<typeof useWishlistLazyQuery>;
export type WishlistQueryResult = Apollo.QueryResult<WishlistQuery, WishlistQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Node": [
      "GaranziaNode",
      "IndirizzoNode",
      "OrdineNode",
      "ProdottoNode",
      "RigaOrdineNode",
      "StatoNode",
      "UtenteNode"
    ],
    "RigaType": [
      "ProdottoNode",
      "RigaCarrelloNode",
      "RigaCheckoutNode",
      "RigaWishlistNode"
    ]
  }
};
      export default result;
    